import {
  Alert,
  Badge,
  Card,
  Checkbox,
  Col,
  Collapse,
  ConfigProvider,
  Divider,
  Drawer,
  Flex,
  Form,
  Modal,
  Popover,
  Radio,
  Row,
  Select,
  Slider,
  Steps,
  Switch,
  Table,
  Tag,
  Button as AntdButton,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import Text from "../../components/Text/Text";
import { CardContainer } from "../../components/Card/CardContainer";
import Permission from "../../components/Permission/Permission";
import Button from "../../components/Button/Button";
import {
  CheckOutlined,
  DownOutlined,
  FilterOutlined,
  RedoOutlined,
  RightOutlined,
  ScanOutlined,
  SearchOutlined,
  UpOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import Input from "../../components/Input/Input";
import { color, icon } from "../../resource";
import {
  createRuleEachShop,
  createShopSameCondition,
  deleteRuleEachShop,
  getAllRule,
  getAllRuleEachShop,
  getRuleEachShop,
  getShopSameCondition,
  updateRuleEachShop,
  updateStatusEachShop,
} from "../../datasource/AdvanceCreditAppoveDatasource";
import { useEffectOnce } from "react-use";
import { TimeLineStyled } from "./CreateAdvanceCreditSetting";
import { onInputNumberKeyPress } from "../../utility/validator";
import { FlexCol } from "../../components/Container/Container";
import { priceFormatter } from "../../utility/Formatter";
import { ModalApproveDetail, SequnceDetail } from "./IndexAdvanceCreditSetting";
import dayjs from "dayjs";
import { useMessageContext } from "../../context/MessageProvider";
import { useSearchParams } from "react-router-dom";
import image from "../../resource/image";
import SortFieldCustom from "../../components/SortFieldTable/SortFieldCustom";
import { useTabState } from "../../hook/useTabState";
import { getShopGroup } from "../../datasource/ShopGroupDatasoure";
import { zoneDatasource } from "../../datasource/ZoneDatasource";
import "./AdvanceCreditClass.css";
import NewModalInfoCredit from "../../components/Modal/NewModalInfoCredit";
import { FixedType } from "rc-table/lib/interface";
import styled from "styled-components";

const StyledTable = styled(Table)`
  .custom-row > td,
  .custom-row:hover > td,
  .custom-row > td.ant-table-cell-row-hover {
    background: #fff7e8 !important;
  }

  .custom-row-white > td,
  .custom-row-white:hover > td,
  .custom-row-white > td.ant-table-cell-row-hover {
    background: #fff !important;
  }
`;

export const IndexAdvanceEachShop: React.FC = () => {
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const { messageApi } = useMessageContext();
  const orderTabState = useTabState();
  const [loading, setLoading] = useState<boolean>(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);
  const [expandSourceByRowKey, setExpandSourceByRowKey] = useState<Record<string, string>>({});
  const [ruleList, setRuleList] = useState<any>([]);
  const [shopRuleList, setShopRuleList] = useState<any>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page") || "1");
  const [take, setTake] = useState(searchParams.get("take") || "10");
  const [searchText, setSearchText] = useState(searchParams.get("searchText") || "");
  const [filterDrawer, setFilterDrawer] = useState<boolean>(false);
  const [statusModal, setStatusModal] = useState<{
    open: boolean;
    name: string;
    data: any;
    checked?: boolean;
  }>();
  const [sameConditionModal, setSameConditionModal] = useState<boolean>(false);
  const [filterList, setFilterList] = useState<{
    statusRule: string[] | undefined;
    statusLimitCredit: string[] | undefined;
    limitCreditPercentMin: number | undefined;
    limitCreditPercentMax: number | undefined;
    ruleIds: string[] | undefined;
    noRule: boolean | undefined;
    customerGroupName: string[] | undefined;
    zone: string[] | undefined;
    statusCustom: string[] | undefined;
  }>({
    statusRule: undefined,
    statusLimitCredit: undefined,
    limitCreditPercentMin: undefined,
    limitCreditPercentMax: undefined,
    ruleIds: undefined,
    noRule: undefined,
    customerGroupName: undefined,
    zone: undefined,
    statusCustom: undefined,
  });
  const [shopNoRule, setShopNoRule] = useState<any>([]);
  const [infoCreditModal, setInfoCreditModal] = useState<{
    open: boolean;
    cusComId: any;
  }>({ open: false, cusComId: null });

  const setParams = (page: string, take: string, searchText: string) => {
    setSearchParams({
      page,
      take,
      searchText,
    });
  };

  const getRuleList = async () => {
    await getRuleEachShop(profile?.company).then((res) => {
      setRuleList(res);
    });
  };

  const getShopRuleList = async () => {
    setLoading(true);
    setExpandSourceByRowKey({});
    await getAllRuleEachShop({
      company: profile?.company,
      page: page,
      take: take,
      search: searchText,
      sortBy: page === "1" && !orderTabState.sortField ? "updateDate" : orderTabState.sortField,
      sortDirection:
        page === "1" && !orderTabState.sortDirection ? "DESC" : orderTabState.sortDirection,
      statusRule: filterList.statusRule
        ? filterList.statusRule.length > 1
          ? undefined
          : filterList.statusRule?.[0]
        : undefined,
      statusLimitCredit: filterList.statusLimitCredit
        ? filterList.statusLimitCredit.length > 1
          ? undefined
          : filterList.statusLimitCredit?.[0]
        : undefined,
      limitCreditPercentMin: filterList.limitCreditPercentMin,
      limitCreditPercentMax: filterList.limitCreditPercentMax,
      ruleIds: filterList.ruleIds,
      noRule: filterList.noRule,
      customerGroupName: filterList.customerGroupName,
      zone: filterList.zone,
      statusCustom: filterList?.statusCustom
        ? filterList?.statusCustom?.length > 1
          ? undefined
          : filterList?.statusCustom?.[0]
        : undefined,
    }).then((res) => {
      const mapData = res.data.map((item: any) => ({
        ...item,
        customConditions:
          item.customConditions && item.customConditions.length > 0
            ? item.customConditions
            : item.conditions,
      }));
      setShopRuleList({ ...res, data: mapData });
      setTimeout(() => {
        setLoading(false);
      }, 300);
    });
  };

  const getShopNoRuleList = async () => {
    await getAllRuleEachShop({
      company: profile?.company,
      page: 1,
      take: 1,
      noRule: true,
    }).then((res) => {
      setShopNoRule(res);
    });
  };

  useEffectOnce(() => {
    getRuleList();
    getShopNoRuleList();
  });

  useEffect(() => {
    setExpandedRowKeys([]);
    getShopRuleList();
  }, [page, take, searchText, orderTabState.sortField, orderTabState.sortDirection]);

  useEffect(() => {
    setExpandedRowKeys([]);
    const checkFilter = Object.entries(filterList).filter(
      ([key, value]: any) =>
        key !== "noRule" &&
        key !== "limitCreditPercentMin" &&
        value !== undefined &&
        value !== null,
    ).length;
    setPage("1");
    setParams("1", take, searchText);
    getShopRuleList();
  }, [filterList]);

  const PageTitle = () => {
    return (
      <>
        <Row justify={"space-between"}>
          <Col>
            <Text level={4} fontWeight={600}>
              ตั้งค่าวงเงินเกินรายร้าน
            </Text>
          </Col>
          <Permission permission={["advanceCreditLimitEachShop", "edit"]}>
            <Col>
              <Button
                type='primary'
                title={
                  <>
                    <ScanOutlined style={{ fontSize: "18px" }} /> เพิ่มเงื่อนไขเดียวกัน
                  </>
                }
                height={40}
                size='large'
                onClick={() => setSameConditionModal(true)}
              />
            </Col>
          </Permission>
        </Row>
        <br />
        {shopNoRule?.count > 0 && (
          <Alert
            type='warning'
            icon={<WarningOutlined />}
            showIcon
            description={
              <>
                <Text level={6}>
                  <b> มี {shopNoRule?.count} ร้านค้า ยังไม่มีกฎการอนุมัติวงเงินเกิน</b>&nbsp;
                  ซึ่งจะสั่งซื้อเกินวงเงินได้เพียง 1 ครั้งก่อนถูกบล็อกอัตโนมัติ
                </Text>{" "}
                &nbsp;&nbsp;
                <Text
                  color='primary'
                  level={6}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSearchText("");
                    setPage("1");
                    setParams("1", take, "");
                    setFilterList((prev) => ({
                      statusRule: undefined,
                      statusLimitCredit: undefined,
                      limitCreditPercentMin: undefined,
                      limitCreditPercentMax: undefined,
                      ruleIds: [],
                      noRule: true,
                      customerGroupName: undefined,
                      zone: undefined,
                      statusCustom: undefined,
                    }));
                  }}
                >
                  <u>กรองดูร้านค้า</u>
                </Text>
              </>
            }
            style={{ padding: "10px", borderRadius: "8px" }}
          />
        )}
        <br />
        <Row justify={"space-between"} gutter={8}>
          <Col span={22}>
            <Input
              placeholder='ค้นหารหัส / ชื่อร้านค้า'
              allowClear
              suffix={<SearchOutlined />}
              defaultValue={searchText}
              onPressEnter={(e) => {
                const value = (e.target as HTMLTextAreaElement).value;
                setSearchText(value);
                setPage("1");
                setParams("1", take, value);
              }}
              onChange={(e) => {
                const value = (e.target as HTMLInputElement).value;
                if (!value) {
                  setSearchText("");
                  setPage("1");
                  setParams("1", take, "");
                }
              }}
              width='100%'
            />
          </Col>
          <Col span={2}>
            <Button
              typeButton='primary-light'
              title={
                <>
                  <Badge
                    count={
                      Object.entries(filterList).filter(
                        ([key, value]: any) =>
                          key !== "noRule" &&
                          key !== "limitCreditPercentMin" &&
                          value !== undefined &&
                          value !== null,
                      ).length
                    }
                    size='small'
                    color={color.warning}
                  >
                    <FilterOutlined style={{ fontSize: "18px", color: color.primary }} />{" "}
                  </Badge>
                  ตัวกรอง
                </>
              }
              height={40}
              size='large'
              onClick={() => setFilterDrawer(true)}
            />
          </Col>
        </Row>
        <Row justify={"end"} gutter={8}>
          <Col style={{ paddingTop: "18px" }}>
            <Text level={6}>{shopRuleList?.count} รายการ</Text>
          </Col>
        </Row>
      </>
    );
  };

  const columns: any = [
    {
      title: (
        <SortFieldCustom
          title='ชื่อร้านค้า'
          sortDirection={
            orderTabState.sortField === "customerName" ? orderTabState.sortDirection : undefined
          }
          onSortChange={() => orderTabState.handleSortChange("customerName")}
        />
      ),
      dataIndex: "customerName",
      key: "customerName",
      render: (value: any, record: any) => {
        return (
          <Row justify={"space-between"} gutter={8} style={{ position: "relative" }}>
            <Col>
              <Text>{value}</Text>
              <br />
              <Text color='Text3' level={6}>
                {record.customerNo} • {record.zone}
              </Text>
              <br />
              <Text color='Text3' level={6}>
                {record.customerGroupName || "-"}
              </Text>
            </Col>
            <Col style={{ paddingTop: "30px", position: "absolute", right: 0 }}>
              <AntdButton
                size='small'
                style={{ width: "30px" }}
                onClick={() =>
                  setInfoCreditModal({ open: true, cusComId: record.customerCompanyId })
                }
              >
                <img
                  src={icon.icon_view_limit_credit}
                  alt='view limit credit'
                  style={{ height: "20px" }}
                />
              </AntdButton>
            </Col>
          </Row>
        );
      },
    },
    {
      title: "ตั้งค่าสั่งวงเงินเกิน",
      dataIndex: "statusRule",
      key: "statusRule",
      render: (value: any, record: any) => {
        const mapChecked = value === null ? false : value;
        return (
          <>
            <Switch
              checked={mapChecked}
              disabled={record.customConditions?.length === 0}
              onChange={(checked) => {
                if (record.customConditions?.length > 0) {
                  setStatusModal({
                    open: true,
                    name: "statusRule",
                    data: record,
                    checked,
                  });
                  return;
                } else {
                  setExpandedRowKeyWithSource(record, "statusRule");
                }
              }}
            />
            <br />
            <Row gutter={8}>
              <Col>
                <Text color='Text3' level={6}>
                  {mapChecked ? "เปิดใช้งาน" : "ปิดใช้งาน"}
                </Text>
              </Col>
              <Col>
                {mapChecked && !record?.statusLimitCredit && (
                  <Popover
                    content={
                      <Text level={6} style={{ color: color.white }}>
                        อนุมัติเกินวงเงินได้ไม่จำกัด
                      </Text>
                    }
                    trigger='hover'
                    color={color.BK}
                  >
                    <img src={icon.icon_infinity} alt='infinity' style={{ height: "10px" }} />
                  </Popover>
                )}
              </Col>
            </Row>
          </>
        );
      },
    },
    {
      title: "ตั้งค่าเพดานวงเงินเกิน",
      dataIndex: "statusLimitCredit",
      key: "statusLimitCredit",
      render: (value: any, record: any) => {
        const mapChecked = value === null ? false : value;
        const limitPercent =
          record?.customLimitCreditPercent ||
          record?.customConditions[record?.customConditions.length - 1]?.max ||
          0;
        return (
          <>
            <Row justify={"start"} gutter={16} style={{ position: "relative" }}>
              <Col>
                <Switch
                  checked={mapChecked}
                  disabled={record.customConditions?.length === 0}
                  onChange={(checked) => {
                    if (record.customConditions?.length > 0 && limitPercent > 0) {
                      setStatusModal({
                        open: true,
                        name: "statusLimitCredit",
                        data: record,
                        checked,
                      });
                      return;
                    } else {
                      setExpandedRowKeyWithSource(record, "statusLimitCredit");
                    }
                  }}
                />
              </Col>
              {value && limitPercent > 0 && (
                <Col span={8} style={{ paddingTop: "5px" }}>
                  <div
                    style={{
                      width: 70,
                      height: 2,
                      background: record?.customLimitCreditPercent ? color.warning : "#8B97A8",
                      paddingLeft: "25%",
                    }}
                  />
                  <Text
                    level={6}
                    fontWeight={600}
                    color='BK'
                    style={{
                      paddingLeft: "25%",
                    }}
                  >
                    {limitPercent} %
                  </Text>
                </Col>
              )}
            </Row>
            <Row justify={"start"} gutter={16}>
              <Col>
                <Text color='Text3' level={6}>
                  {value ? "เปิดใช้งาน" : "ปิดใช้งาน"}
                </Text>
              </Col>
              {value && limitPercent > 0 && (
                <Col>
                  <Text level={6}>{priceFormatter(record?.calCreditLimit, 2, true)}</Text>
                </Col>
              )}
            </Row>
          </>
        );
      },
    },
    {
      title: "กฎการอนุมัติ",
      dataIndex: "ruleName",
      key: "ruleName",
      render: (value: any, record: any) => <Text>{record?.rule?.ruleName || "-"}</Text>,
    },
    {
      title: "ลำดับอนุมัติ",
      dataIndex: "conditionOrder",
      key: "conditionOrder",
      render: (value: any, record: any) => {
        const conditions = record?.customConditions ?? [];
        const displayConditions =
          conditions.length > 3
            ? [...conditions.slice(0, 2), { isEllipsis: true }, conditions[conditions.length - 1]]
            : conditions;
        return (
          <>
            <Row justify={"start"} gutter={2} style={{ cursor: "default" }}>
              {displayConditions?.length > 0
                ? displayConditions.map((condition: any, index: number) => (
                    <React.Fragment key={condition.isEllipsis ? "ellipsis" : condition.groupNo}>
                      <Col>
                        {condition.isEllipsis ? (
                          <div style={{ paddingTop: "15px" }}>
                            <Text strong>...</Text>
                          </div>
                        ) : (
                          <Card
                            style={{
                              textAlign: "center",
                              backgroundColor: "#F3F6F9",
                              borderColor: condition.statusCustomMax ? color.warning : "#F3F6F9",
                            }}
                            bodyStyle={{
                              paddingTop: "6px",
                              paddingBottom: "6px",
                              paddingLeft: "4px",
                              paddingRight: "4px",
                            }}
                          >
                            <Badge
                              count={conditions.indexOf(condition) + 1}
                              color='#1B4586'
                              style={{
                                width: 20,
                                height: 20,
                                lineHeight: "20px",
                                borderRadius: "50%",
                                fontSize: 16,
                              }}
                            />
                            <br />
                            <Text level={6}>
                              {condition.max
                                ? `${condition.min}%-${condition.max}%`
                                : `> ${condition.min}%`}
                            </Text>
                          </Card>
                        )}
                      </Col>

                      {index !== displayConditions.length - 1 && (
                        <Col style={{ display: "flex", alignItems: "center" }}>
                          <RightOutlined style={{ fontSize: 12 }} />
                        </Col>
                      )}
                    </React.Fragment>
                  ))
                : "-"}
            </Row>
          </>
        );
      },
    },
    {
      title: (
        <SortFieldCustom
          title='สถานะ'
          sortDirection={
            orderTabState.sortField === "statusCustom" ? orderTabState.sortDirection : undefined
          }
          onSortChange={() => orderTabState.handleSortChange("statusCustom")}
        />
      ),
      dataIndex: "statusCustom",
      key: "statusCustom",
      fixed: "right" as FixedType | undefined,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ position: "relative" }}>
              {!value ? (
                <Tag style={{ borderRadius: "20px", position: "relative" }}>
                  <Text
                    fontSize={12}
                    fontWeight={600}
                    style={{ cursor: "default", position: "relative" }}
                  >
                    ค่าเริ่มต้น
                  </Text>
                </Tag>
              ) : (
                <Popover
                  content={
                    <Text level={6} style={{ color: color.white }}>
                      {`"ปรับแต่ง" แสดงเฉพาะการปรับ`} <br />
                      {`% ลำดับการอนุมัติ และ % เพดานเกินวงเงิน`}
                    </Text>
                  }
                  trigger='hover'
                  color={color.BK}
                >
                  <Tag
                    style={{
                      borderRadius: "20px",
                      borderColor: color.warning,
                      position: "relative",
                    }}
                  >
                    <Badge color={color.warning} style={{ position: "relative" }} />
                    &nbsp;
                    <Text
                      fontSize={12}
                      fontWeight={600}
                      color='warning'
                      style={{ cursor: "pointer" }}
                    >
                      ปรับแต่ง
                    </Text>
                  </Tag>
                </Popover>
              )}
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "",
      key: "expand",
      width: 120,
      fixed: "right" as FixedType | undefined,
      render: (_, record) => {
        const expanded = expandedRowKeys.includes(record.customerCompanyId);
        return (
          <Tag
            style={{
              width: "100%",
              textAlign: "center",
              cursor: "pointer",
              margin: 0,
            }}
            onClick={() => {
              const rowKey = record.customerCompanyId;

              if (expanded) {
                setExpandedRowKeys((prev) => prev.filter((k) => k !== rowKey));
              } else {
                setExpandedRowKeys((prev) => [...prev, rowKey]);
              }
            }}
          >
            <Text level={6} color='primary'>
              {expanded ? "ซ่อน" : "ดูข้อมูล"}
            </Text>
            {expanded ? <UpOutlined /> : <DownOutlined />}
          </Tag>
        );
      },
    },
    //Table.EXPAND_COLUMN,
  ];

  const onChangeStatus = async (data: any, name: string, checked?: boolean) => {
    const payload: any = {};
    if (name === "statusRule") {
      payload["statusRule"] = checked;
      if (!checked && data.statusLimitCredit) {
        payload["statusLimitCredit"] = false;
      }
    }
    if (name === "statusLimitCredit") {
      payload["statusLimitCredit"] = checked;
      if (checked && !data.statusRule) {
        payload["statusRule"] = checked;
      }
    }
    payload.ruleCustomerCompanyId = data.ruleCustomerCompanyId;
    payload.updateBy = profile?.firstname + " " + profile?.lastname;

    await updateStatusEachShop(payload).then((res) => {
      if (res.success) {
        setStatusModal({ open: false, name: "", data: null, checked: false });
        getShopRuleList();
        getShopNoRuleList();
        messageApi.success("บันทึกสำเร็จ");
      }
    });
  };

  const setExpandedRowKeyWithSource = (record: any, sourceKey: string) => {
    const rowKey = String(record.customerCompanyId);
    setExpandSourceByRowKey((prev) => ({ ...prev, [rowKey]: sourceKey }));
    setExpandedRowKeys((prev) =>
      prev.includes(record.customerCompanyId) ? prev : [...prev, record.customerCompanyId],
    );
  };

  return (
    <>
      <CardContainer>
        <PageTitle />
        <br />
        <ConfigProvider
          theme={{
            components: {
              Table: {
                headerBg: "#F3F6F9",
                fontFamily: "IBM Plex Sans Thai",
                fontSize: 15,
                rowExpandedBg: "#F3F6F9",
              },
            },
          }}
        >
          <StyledTable
            rowClassName={(record: any) =>
              record.statusCustom ? "custom-row" : "custom-row-white"
            }
            loading={loading}
            columns={columns}
            scroll={{
              x: "max-content",
            }}
            expandable={{
              showExpandColumn: false,
              expandIcon: () => null,
              expandedRowKeys,
              onExpand: (expanded: boolean, record: any) => {
                const rowKey = String(record.customerCompanyId);
                if (expanded) {
                  setExpandSourceByRowKey((prev) => {
                    if (prev[rowKey]) {
                      return prev;
                    }
                    return { ...prev, [rowKey]: "expandIcon" };
                  });
                } else {
                  setExpandSourceByRowKey((prev) => {
                    const next = { ...prev };
                    delete next[rowKey];
                    return next;
                  });
                }
                setExpandedRowKeys((prev) =>
                  expanded
                    ? prev.includes(record.customerCompanyId)
                      ? prev
                      : [...prev, record.customerCompanyId]
                    : prev.filter((key) => key !== record.customerCompanyId),
                );
              },
              expandedRowRender: (record: any) => {
                const mapRowData = { ...record };
                const rowKey = String(record.customerCompanyId);
                mapRowData.ruleId = record.rule?.ruleId;
                mapRowData.customConditions =
                  record?.customConditions && record?.customConditions.length > 0
                    ? record.customConditions
                    : record.conditions;
                mapRowData.expandedRowKey = rowKey;
                mapRowData.activeFromColumnKey = expandSourceByRowKey[rowKey] || "expandIcon";
                mapRowData.editConditions =
                  record?.customConditions && record?.customConditions.length > 0
                    ? record.customConditions
                    : record.conditions;
                return (
                  <ExpandDetail
                    rowData={mapRowData}
                    ruleList={ruleList}
                    fetchList={() => {
                      getShopRuleList();
                      getShopNoRuleList();
                      setPage("1");
                      setParams("1", take, searchText);
                    }}
                  />
                );
              },
            }}
            rowKey='customerCompanyId'
            dataSource={shopRuleList?.data}
            pagination={{
              position: ["bottomCenter"],
              pageSize: Number(take),
              current: Number(page),
              total: shopRuleList?.count,
              align: "center",
              showQuickJumper: false,
              showSizeChanger: {
                showSearch: false,
              },
              onChange: (page, pageSize) => {
                setPage(`${page}`);
                setTake(`${pageSize}`);
                setParams(`${page}`, `${pageSize}`, searchText);
              },
            }}
            locale={{
              emptyText: () => (
                <div
                  style={{
                    height: "400px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Col>
                    <img src={image.emptyTableBrand} alt='empty_table' />
                  </Col>
                  <Col>
                    <div style={{ fontSize: "16px" }}>ไม่พบรายการที่ค้นหา</div>
                  </Col>
                </div>
              ),
            }}
          />
        </ConfigProvider>
      </CardContainer>
      {statusModal?.open && (
        <Modal
          open={statusModal.open}
          maskClosable={false}
          keyboard={false}
          onCancel={() => setStatusModal({ open: false, checked: false, name: "", data: null })}
          centered
          cancelButtonProps={{ style: { borderColor: color.primary, color: color.primary } }}
          title={
            <Text level={3} fontWeight={600}>
              ยืนยัน {statusModal.checked ? "เปิดใช้งาน" : "ปิดใช้งาน"}{" "}
              {statusModal.name === "statusLimitCredit" ? "เพดานวงเงินเกิน" : "สั่งวงเงินเกิน"}
            </Text>
          }
          okText='ยืนยัน'
          onOk={() => onChangeStatus(statusModal.data, statusModal.name, statusModal.checked)}
        >
          <Text level={3} fontWeight={600}>{`"${statusModal.data?.customerName}"`}</Text>
          <br />
          <Text color='Text3' level={6}>
            โปรดตรวจสอบรายละเอียดการตั้งค่าอีกครั้งก่อนกดยืนยัน
          </Text>
        </Modal>
      )}
      {filterDrawer && (
        <FilterDrawer
          filterDrawer={filterDrawer}
          setFilterDrawer={setFilterDrawer}
          setFilterList={setFilterList}
          filterList={filterList}
          limitCreditPercentMax={shopRuleList?.summaryLength?.max}
          limitCreditPercentMin={shopRuleList?.summaryLength?.min}
        />
      )}
      {sameConditionModal && (
        <SameConditionModal
          setSameConditionModal={setSameConditionModal}
          sameCondition={sameConditionModal}
          ruleList={ruleList}
          fetchList={() => {
            getShopRuleList();
            getShopNoRuleList();
          }}
        />
      )}
      {infoCreditModal.open && (
        <NewModalInfoCredit
          open={infoCreditModal.open}
          onClose={() => setInfoCreditModal({ open: false, cusComId: null })}
          cusComId={infoCreditModal.cusComId}
        />
      )}
    </>
  );
};

export const SameConditionModal = ({
  setSameConditionModal,
  sameCondition,
  ruleList,
  fetchList,
}: {
  setSameConditionModal: any;
  sameCondition: boolean;
  ruleList: any;
  fetchList: any;
}) => {
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const [formSameCondition] = Form.useForm();
  const _watchStatus = Form.useWatch("statusRule", formSameCondition);
  const { messageApi } = useMessageContext();
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(0);
  const [changedFields, setChangedFields] =
    useState<{ groupNo: number; text: string; value: any }[]>();
  const scrollRef = useRef<HTMLDivElement>(null);

  const [messageErrorSteps, setMessageErrorSteps] = useState<{ key: number; text: string }[]>([]);
  const [shopList, setShopList] = useState<any>([]);
  const [searchShopList, setSearchShopList] = useState<any>([]);
  const [searchText, setSearchText] = useState<string | undefined>(undefined);
  const [searchCusGroup, setSearchCusGroup] = useState<any>(undefined);
  const [searchRuleIds, setSearchRuleIds] = useState<any>(undefined);
  const [searchZone, setSearchZone] = useState<any>(undefined);
  const [cusGroupList, setCusGroupList] = useState<any>([]);
  const [zoneList, setZoneList] = useState<any>([]);
  const [openCategory, setOpenCategory] = useState<any[]>([
    { key: "statusRule", status: false },
    { key: "statusLimitCredit", status: false },
    { key: "changeRule", status: false },
  ]);
  const [shopErrorModal, setShopErrorModal] = useState<boolean>(false);
  const optionRule: any = [
    { label: "ไม่มีกฎ", value: "NONE" },
    ...((ruleList || [])?.map((rule: any) => ({
      label: rule?.ruleName,
      value: rule?.ruleId,
    })) || []),
  ];
  const fetchCustomerGroup = async () => {
    await getShopGroup({ page: 1, take: 999, company: profile.company, isActive: true }).then(
      (res) => {
        const mapData = res.responseData.data.map((group: any) => ({
          label: group.customerGroupName,
          value: group.customerGroupName,
          key: group.customerGroupName,
        }));
        setCusGroupList(mapData);
      },
    );
  };
  const fetchZone = async () => {
    await zoneDatasource.getAllZoneByCompany(profile.company).then((res) => {
      setZoneList(res);
    });
  };

  useEffectOnce(() => {
    fetchCustomerGroup();
    fetchZone();
    fetchShop(setShopList);
  });

  const fetchShop = async (setState: any) => {
    setLoading(true);
    await getShopSameCondition({
      company: profile.company,
      search: searchText,
      customerGroupName: searchCusGroup,
      zone: searchZone,
      ruleId: searchRuleIds,
    }).then((res) => {
      const mapKey = res.data.map((shop: any, index: number) => ({
        ...shop,
        checked:
          shopList?.find(
            (selectedShop: any) => selectedShop.customerCompanyId === shop.customerCompanyId,
          )?.checked || false,
        key: shop.customerCompanyId,
      }));
      setState(mapKey);
    });
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  useEffect(() => {
    fetchShop(setSearchShopList);
  }, [searchText, searchCusGroup, searchZone, searchRuleIds]);

  const onChangeRule = (value: any) => {
    const selectedRule = ruleList.find((rule: any) => rule.ruleId === value);
    formSameCondition.setFieldsValue({
      ...formSameCondition.getFieldsValue(true),
      ruleId: selectedRule?.ruleId,
      conditions: selectedRule?.conditions,
      customConditions: selectedRule?.conditions ?? [],
      editConditions: selectedRule?.conditions ?? [],
      limitCreditPercent: selectedRule?.limitCreditPercent,
    });
  };

  const stepOne = () => {
    const columns: any = [
      {
        title: (
          <Checkbox
            checked={searchShopList?.every((shop: any) => shop.checked)}
            onChange={(e) => {
              const checked = e.target.checked;
              const mapShop = shopList.map((shop: any) => {
                const findShop = searchShopList.find(
                  (selectedShop: any) =>
                    `${selectedShop.customerCompanyId}` === `${shop.customerCompanyId}`,
                );
                if (findShop) {
                  return { ...shop, checked };
                }
                return { ...shop, checked: shop.checked };
              });
              const mapSearchShop = searchShopList.map((shop: any) => ({ ...shop, checked }));
              setShopList(mapShop);
              setSearchShopList(mapSearchShop);
              setMessageErrorSteps([]);
            }}
          />
        ),
        dataIndex: "checked",
        key: "checked",
        render: (value: any, record: any) => {
          return (
            <>
              <Checkbox
                checked={value}
                onChange={(e) => {
                  const checked = e.target.checked;
                  const mapShop = shopList.map((shop: any) =>
                    shop.customerCompanyId === record.customerCompanyId
                      ? { ...shop, checked }
                      : shop,
                  );
                  const mapSearchShop = searchShopList.map((shop: any) =>
                    shop.customerCompanyId === record.customerCompanyId
                      ? { ...shop, checked }
                      : shop,
                  );
                  setSearchShopList(mapSearchShop);
                  setShopList(mapShop);
                  setMessageErrorSteps([]);
                }}
              />
            </>
          );
        },
      },
      {
        title: "ชื่อร้านค้า",
        dataIndex: "customerName",
        key: "customerName",
        render: (value: any, record: any) => {
          return (
            <>
              {value}
              <br />
              <Text level={6} color='Text3'>
                {record.customerNo} {record.customerGroupName && <>• {record.customerGroupName}</>}
              </Text>
            </>
          );
        },
      },
      {
        title: "เขต",
        dataIndex: "zone",
        key: "zone",
        render: (value: any, record: any) => {
          return <>{value}</>;
        },
      },
      {
        title: "สั่งวงเงินเกิน",
        dataIndex: "statusRule",
        key: "statusRule",
        render: (value: any, record: any) => {
          return (
            <>
              {record.ruleId ? (
                <Tag color={value ? "#F0FDF4" : "#EFF2F9"}>
                  <Text level={6} color={value ? "darkGreen" : "Grey"}>
                    {value ? "เปิดใช้งาน" : "ปิดใช้งาน"}
                  </Text>
                </Tag>
              ) : (
                <>-</>
              )}
            </>
          );
        },
      },
      {
        title: "เพดาน",
        dataIndex: "statusLimitCredit",
        key: "statusLimitCredit",
        render: (value: any, record: any) => {
          return (
            <>
              {record.ruleId ? (
                <Tag color={value ? "#F0FDF4" : "#EFF2F9"}>
                  <Text level={6} color={value ? "darkGreen" : "Grey"}>
                    {value ? "เปิดใช้งาน" : "ปิดใช้งาน"}
                  </Text>
                </Tag>
              ) : (
                <>-</>
              )}
            </>
          );
        },
      },
      {
        title: "% เพดาน",
        dataIndex: "limitCreditPercent",
        key: "limitCreditPercent",
        render: (value: any, record: any) => {
          return (
            <>
              <Text level={6}>{value ? `${value} %` : "-"}</Text>
            </>
          );
        },
      },
      {
        title: "กฎการอนุมัติ",
        dataIndex: "ruleName",
        key: "ruleName",
        render: (value: any, record: any) => {
          return <>{value ? value : "-"}</>;
        },
      },
    ];

    return (
      <div key={0}>
        <Row gutter={8} justify={"space-between"} style={{ paddingBottom: "10px" }}>
          <Col span={12}>
            <Input
              allowClear
              placeholder='ค้นหารหัส/ชื่อร้านค้า'
              suffix={<SearchOutlined />}
              onChange={(e) => {
                if (!e.target.value) {
                  setSearchText(undefined);
                }
              }}
              onPressEnter={(e) => setSearchText(e.currentTarget.value)}
            />
          </Col>
          <Col span={4}>
            <Select
              getPopupContainer={() => scrollRef.current!}
              mode='multiple'
              allowClear
              options={cusGroupList}
              style={{ width: "100%", height: "100%" }}
              placeholder='กลุ่มลูกค้า'
              value={searchCusGroup}
              onChange={setSearchCusGroup}
              showSearch={false}
              menuItemSelectedIcon={null}
              maxTagCount={0}
              tagRender={({ value, closable, onClose }) => {
                return (
                  <Row
                    justify={"space-between"}
                    gutter={16}
                    style={{ paddingLeft: "6px", paddingTop: "6px" }}
                  >
                    <Col>
                      <Text level={6} fontWeight={600}>
                        กลุ่มลูกค้า
                      </Text>
                    </Col>
                    <Col>
                      <Badge
                        count={searchCusGroup?.length}
                        style={{ backgroundColor: "#FFF4E6", color: "#faad14", fontWeight: "bold" }}
                      />
                    </Col>
                  </Row>
                );
              }}
              optionRender={(option: any) => {
                return (
                  <Row justify={"space-between"} style={{ zIndex: -1 }}>
                    <Col>
                      <Checkbox checked={searchCusGroup?.includes(option.value)}>
                        {option.label}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              }}
            />
          </Col>
          <Col span={3}>
            <Select
              getPopupContainer={() => scrollRef.current!}
              mode='multiple'
              allowClear
              options={zoneList?.map((zone: any) => ({
                label: zone.zoneName,
                value: zone.zoneName,
              }))}
              style={{ width: "100%", height: "100%" }}
              placeholder='เขต'
              value={searchZone}
              onChange={(e) => setSearchZone(e)}
              showSearch={false}
              menuItemSelectedIcon={null}
              maxTagCount={0}
              tagRender={({ value, closable, onClose }) => {
                return (
                  <Row
                    justify={"space-between"}
                    gutter={16}
                    style={{ paddingLeft: "6px", paddingTop: "6px" }}
                  >
                    <Col>
                      <Text level={6} fontWeight={600}>
                        เขต
                      </Text>
                    </Col>
                    <Col>
                      <Badge
                        count={searchZone?.length}
                        style={{ backgroundColor: "#FFF4E6", color: "#faad14", fontWeight: "bold" }}
                      />
                    </Col>
                  </Row>
                );
              }}
              optionRender={(option: any) => {
                return (
                  <Row justify={"space-between"}>
                    <Col>
                      <Checkbox checked={searchZone?.includes(option.value)}>
                        {option.label}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              }}
            />
          </Col>
          <Col span={5}>
            <Select
              getPopupContainer={() => scrollRef.current!}
              mode='multiple'
              allowClear
              options={optionRule}
              style={{ width: "100%", height: "100%" }}
              placeholder='กฎการอนุมัติ'
              value={searchRuleIds}
              onChange={(e) => setSearchRuleIds(e)}
              showSearch={false}
              menuItemSelectedIcon={null}
              maxTagCount={0}
              tagRender={({ value, closable, onClose }) => {
                return (
                  <Row
                    justify={"space-between"}
                    gutter={16}
                    style={{ paddingLeft: "6px", paddingTop: "6px" }}
                  >
                    <Col>
                      <Text level={6} fontWeight={600}>
                        กฎการอนุมัติ
                      </Text>
                    </Col>
                    <Col>
                      <Badge
                        count={searchRuleIds?.length}
                        style={{ backgroundColor: "#FFF4E6", color: "#faad14", fontWeight: "bold" }}
                      />
                    </Col>
                  </Row>
                );
              }}
              optionRender={(option: any) => {
                return (
                  <Row justify={"space-between"} style={{ zIndex: -1 }}>
                    <Col>
                      <Checkbox checked={searchRuleIds?.includes(option.value)}>
                        {option.label}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              }}
            />
          </Col>
        </Row>
        <ConfigProvider
          theme={{
            components: {
              Table: {
                headerBg: "#1B4586",
                colorTextHeading: "white",
                fontFamily: "IBM Plex Sans Thai",
                fontSize: 15,
                rowHoverBg: "none",
                rowSelectedBg: "none",
                rowSelectedHoverBg: "none",
              },
            },
          }}
        >
          <Table
            style={{ minHeight: "400px" }}
            loading={loading}
            columns={columns}
            dataSource={searchShopList}
            pagination={false}
            size='small'
          />
        </ConfigProvider>
      </div>
    );
  };

  const stepTwo = () => {
    return (
      <div key={1}>
        <Text>เลือกกำหนดเงื่อนไขเดียวกัน (Apply) ให้ร้านค้าอย่างน้อย 1 หัวข้อ</Text>
        <br />
        <Text>ร้านค้าที่เลือก : </Text>
        <Text fontWeight={600}>
          {searchShopList.filter((shop: any) => shop.checked).length} ร้าน
        </Text>
        <br />
        <Form
          form={formSameCondition}
          layout='vertical'
          onValuesChange={(changedValues) => {
            if (changedValues?.editConditions) {
              const indices: number[] = changedValues.editConditions
                .map((_: any, i: number) =>
                  changedValues.editConditions[i] !== undefined ? i : -1,
                )
                .filter((i: number) => i !== -1);
              if (indices.length > 0) {
                const editConditions = formSameCondition.getFieldValue("editConditions") ?? [];
                const originalConditions = formSameCondition.getFieldValue("conditions") ?? [];
                const conditionsLength = editConditions.length;
                setChangedFields((prev: any) => {
                  let next = [...(prev ?? [])];
                  indices.forEach((i: number) => {
                    const newMax = changedValues.editConditions[i]?.max;
                    const originalMax = originalConditions[i]?.max;
                    const isDifferent = String(newMax ?? "") !== String(originalMax ?? "");
                    const mapText =
                      i + 1 === conditionsLength ? "% เพดานวงเงินเกิน" : "% วงเงินเกินสูงสุด";
                    next = next.filter((field: any) => field.groupNo !== i + 1);
                    if (isDifferent) {
                      next.push({ groupNo: i + 1, text: mapText, value: newMax });
                    }
                  });

                  return next;
                });
              }
            } else {
              const checkRule =
                formSameCondition?.getFieldsValue(true)?.rule?.ruleId === changedValues.ruleId;
              if (!checkRule) {
                setChangedFields((prev: any) => [
                  {
                    groupNo: changedValues["ruleId"],
                    text: "เปลี่ยนกฎการอนุมัติวงเงินเกิน",
                    value: "",
                  },
                ]);
              } else {
                setChangedFields(undefined);
              }
            }
          }}
        >
          <Col span={24} style={{ paddingBottom: "10px" }}>
            <Collapse
              activeKey={
                openCategory.find((item) => item.key === "statusRule")?.status ? ["1"] : []
              }
              items={[
                {
                  key: "1",
                  label: (
                    <>
                      <Text fontWeight={600}>สั่งวงเงินเกิน</Text>
                      <br />
                      <Text color='Text3' level={6}>
                        เปิด/ปิด ร้านค้าสั่งวงเงินเกิน
                      </Text>
                    </>
                  ),
                  extra: (
                    <Row justify={"end"} gutter={16} style={{ paddingTop: "10px" }}>
                      <Col>
                        <Form.Item name='statusRuleCategory' noStyle>
                          <Switch
                            checked={
                              openCategory.find((item) => item.key === "statusRuleCategory")?.status
                            }
                            onChange={(checked) => {
                              setOpenCategory((prev) =>
                                prev.map((item) =>
                                  item.key === "statusRule" ? { ...item, status: checked } : item,
                                ),
                              );
                              if (checked) {
                                formSameCondition.setFieldsValue({ statusRule: "1" });
                              } else {
                                formSameCondition.setFieldsValue({ statusRule: undefined });
                              }
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Text level={6}>
                          {openCategory.find((item) => item.key === "statusRule")?.status
                            ? "กำหนด"
                            : "ไม่กำหนด"}
                        </Text>
                      </Col>
                    </Row>
                  ),
                  showArrow: false,
                  children: (
                    <Form.Item name='statusRule' noStyle>
                      <Radio.Group
                        className='status-radio-group'
                        onChange={(e) => {
                          const inactive = e.target.value === "2";
                          if (inactive) {
                            formSameCondition.setFieldsValue({ statusLimitCredit: "2" });
                          }
                        }}
                      >
                        <Radio value='1'>
                          <Flex vertical>
                            <Text fontWeight={600} level={6}>
                              เปิดการใช้งาน
                            </Text>
                          </Flex>
                        </Radio>
                        <Radio value='2'>
                          <Flex vertical>
                            <Text fontWeight={600} level={6}>
                              ปิดการใช้งาน
                            </Text>
                          </Flex>
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  ),
                },
              ]}
            />
          </Col>
          <Col span={24} style={{ paddingBottom: "10px" }}>
            <Collapse
              activeKey={
                openCategory.find((item) => item.key === "statusLimitCredit")?.status ? ["1"] : []
              }
              items={[
                {
                  key: "1",
                  label: (
                    <>
                      <Text fontWeight={600}>เพดานวงเงินเกิน</Text>
                      <br />
                      <Text color='Text3' level={6}>
                        เปิด/ปิด เพดานวงเงินเกินร้านค้า, กำหนด % เพดาน
                      </Text>
                    </>
                  ),
                  extra: (
                    <Row justify={"end"} gutter={16} style={{ paddingTop: "10px" }}>
                      <Col>
                        <Form.Item name='statusLimitCreditCategory' noStyle>
                          <Switch
                            checked={
                              openCategory.find((item) => item.key === "statusLimitCredit")?.status
                            }
                            onChange={(checked) => {
                              setOpenCategory((prev) =>
                                prev.map((item) =>
                                  item.key === "statusLimitCredit"
                                    ? { ...item, status: checked }
                                    : item,
                                ),
                              );
                              if (checked) {
                                formSameCondition.setFieldsValue({
                                  statusLimitCredit:
                                    formSameCondition.getFieldValue("statusRule") === "2"
                                      ? "2"
                                      : "1",
                                });
                              } else {
                                formSameCondition.setFieldsValue({ statusLimitCredit: undefined });
                              }
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Text level={6}>
                          {openCategory.find((item) => item.key === "statusLimitCredit")?.status
                            ? "กำหนด"
                            : "ไม่กำหนด"}
                        </Text>
                      </Col>
                    </Row>
                  ),
                  showArrow: false,
                  children: (
                    <Form.Item name='statusLimitCredit' noStyle>
                      <Radio.Group
                        className='status-radio-group'
                        disabled={formSameCondition.getFieldValue("statusRule") === "2"}
                      >
                        <Radio
                          value='1'
                          disabled={formSameCondition.getFieldValue("statusRule") === "2"}
                        >
                          <Flex vertical>
                            <Text fontWeight={600} level={6}>
                              เปิดการใช้งาน
                            </Text>
                          </Flex>
                        </Radio>
                        <Radio
                          value='2'
                          disabled={formSameCondition.getFieldValue("statusRule") === "2"}
                        >
                          <Flex vertical>
                            <Text fontWeight={600} level={6}>
                              ปิดการใช้งาน
                            </Text>
                          </Flex>
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  ),
                },
              ]}
            />
          </Col>
          <Col span={24} style={{ paddingBottom: "10px" }}>
            <Collapse
              activeKey={
                openCategory.find((item) => item.key === "changeRule")?.status ? ["1"] : []
              }
              items={[
                {
                  key: "1",
                  label: (
                    <>
                      <Text fontWeight={600}>กฎการอนุมัติ</Text>
                      <br />
                      <Text color='Text3' level={6}>
                        เพิ่มกฎ, เปลี่ยนกฎ, ปรับ % ผู้อนุมัติ และ % เพดาน
                      </Text>
                    </>
                  ),
                  extra: (
                    <Row justify='end' gutter={16} style={{ paddingTop: "10px" }}>
                      <Col>
                        <Form.Item name='changeRule' noStyle>
                          <Switch
                            checked={openCategory.find((item) => item.key === "changeRule")?.status}
                            onChange={(checked) => {
                              setOpenCategory((prev) =>
                                prev.map((item) =>
                                  item.key === "changeRule" ? { ...item, status: checked } : item,
                                ),
                              );
                              formSameCondition.setFieldsValue({
                                changeRule: checked ? "1" : undefined,
                              });
                              !checked &&
                                formSameCondition.setFieldsValue({
                                  ruleId: undefined,
                                  editConditions: [],
                                });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Text level={6}>
                          {openCategory.find((item) => item.key === "changeRule")?.status
                            ? "กำหนด"
                            : "ไม่กำหนด"}
                        </Text>
                      </Col>
                    </Row>
                  ),
                  showArrow: false,
                  children: (
                    <>
                      <Col span={24}>
                        <Form.Item
                          label='กฎการอนุมัติวงเงินเกิน'
                          name='ruleId'
                          rules={[{ required: true, message: "กรุณาเลือกกฎการอนุมัติ" }]}
                        >
                          <Select
                            placeholder='เลือกกฎการอนุมัติ'
                            options={ruleList?.map((rule: any) => ({
                              label: <Text>{rule?.ruleName}</Text>,
                              value: rule?.ruleId,
                              key: rule?.ruleName,
                            }))}
                            style={{ width: "100%", height: "40px" }}
                            onChange={(value) => {
                              onChangeRule(value);
                            }}
                            optionRender={(option: any) => {
                              return (
                                <div
                                  style={{
                                    margin: 0,
                                    lineHeight: "8px",
                                    borderRadius: "4px",
                                    backgroundColor:
                                      option.value === formSameCondition.getFieldValue("ruleId")
                                        ? "#EFF2F9"
                                        : "transparent",
                                  }}
                                >
                                  <Row justify={"space-between"} style={{ padding: "6px" }}>
                                    <Col>
                                      <Text>{option.label}</Text>
                                    </Col>
                                    {option.value === formSameCondition.getFieldValue("ruleId") && (
                                      <Col style={{ paddingTop: "6px" }}>
                                        <CheckOutlined style={{ color: color.primary }} />
                                      </Col>
                                    )}
                                  </Row>
                                </div>
                              );
                            }}
                          />
                        </Form.Item>
                      </Col>
                      {formSameCondition?.getFieldValue("editConditions")?.length > 0 && (
                        <>
                          <Row justify={"end"} gutter={8}>
                            <Col>
                              {changedFields?.some((field) => field.text.includes("%")) ? (
                                <Tag style={{ borderRadius: "20px", borderColor: color.warning }}>
                                  <Badge color={color.warning} />
                                  &nbsp;
                                  <Text fontSize={12} fontWeight={600} color='warning'>
                                    ปรับแต่ง
                                  </Text>
                                </Tag>
                              ) : (
                                <Tag style={{ borderRadius: "20px" }}>
                                  <Text fontSize={12} fontWeight={600}>
                                    ค่าเริ่มต้น
                                  </Text>
                                </Tag>
                              )}
                            </Col>
                          </Row>
                          <br />
                          <Col span={24}>
                            <TimeLineStyled
                              mode='left'
                              items={formSameCondition
                                ?.getFieldValue("editConditions")
                                ?.map((item: any, index: number) => ({
                                  dot: (
                                    <Badge
                                      key={item.groupNo}
                                      count={index + 1}
                                      color='#1B4586'
                                      style={{
                                        width: 20,
                                        height: 20,
                                        lineHeight: "20px",
                                        borderRadius: "50%",
                                        fontSize: 16,
                                      }}
                                    />
                                  ),
                                  color: index === 0 ? "green" : "blue",
                                  children: (
                                    <Card
                                      bodyStyle={{
                                        paddingTop: "6px",
                                        paddingBottom: "6px",
                                      }}
                                    >
                                      <Row justify={"space-between"} gutter={16}>
                                        <Col span={12}>
                                          <div style={{ paddingTop: "30px" }}>
                                            <Text>{item.roleName}</Text>
                                          </div>
                                        </Col>
                                        <Col span={6}>
                                          <Form.Item
                                            label='% วงเงินเกินต่ำสุด'
                                            name={["editConditions", index, "min"]}
                                          >
                                            <Input
                                              placeholder='ระบุ % วงเงินเกินต่ำสุด'
                                              autoComplete='off'
                                              suffix='%'
                                              disabled
                                              style={{ color: color.BK }}
                                              onKeyDown={onInputNumberKeyPress}
                                            />
                                          </Form.Item>
                                        </Col>
                                        <Col span={6}>
                                          <Form.Item
                                            label={
                                              index ===
                                              formSameCondition?.getFieldValue("editConditions")
                                                ?.length -
                                                1
                                                ? "% เพดานวงเงินเกิน"
                                                : "% วงเงินเกินสูงสุด"
                                            }
                                            name={["editConditions", index, "max"]}
                                            rules={[
                                              {
                                                required:
                                                  index ===
                                                  formSameCondition?.getFieldValue("editConditions")
                                                    ?.length -
                                                    1
                                                    ? false
                                                    : true,
                                                message:
                                                  index !=
                                                  formSameCondition?.getFieldValue("editConditions")
                                                    ?.length -
                                                    1
                                                    ? "โปรดระบุ % วงเงินเกินสูงสุด"
                                                    : undefined,
                                              },
                                              {
                                                validator: (_, value) => {
                                                  const limitCreditPercent =
                                                    formSameCondition.getFieldValue(
                                                      "limitCreditPercent",
                                                    );
                                                  const maxPrevValue =
                                                    formSameCondition.getFieldValue([
                                                      "editConditions",
                                                      index - 1,
                                                      "max",
                                                    ]);
                                                  const maxNextValue =
                                                    formSameCondition.getFieldValue([
                                                      "editConditions",
                                                      index + 1,
                                                      "max",
                                                    ]);

                                                  if (parseFloat(value) === 0) {
                                                    return Promise.reject(
                                                      new Error("วงเงินเกินสูงสุดต้องการมากกว่า 0"),
                                                    );
                                                  }
                                                  if (
                                                    value &&
                                                    maxNextValue &&
                                                    parseFloat(maxNextValue) <= parseFloat(value)
                                                  ) {
                                                    return Promise.reject(
                                                      new Error(
                                                        "วงเงินเกินสูงสุดต้องน้อยกว่าลำดับถัดไป",
                                                      ),
                                                    );
                                                  }
                                                  if (
                                                    value &&
                                                    maxPrevValue &&
                                                    parseFloat(maxPrevValue) > parseFloat(value)
                                                  ) {
                                                    const mapErrorText =
                                                      index ===
                                                      Number(
                                                        formSameCondition?.getFieldValue(
                                                          "editConditions",
                                                        )?.length,
                                                      ) -
                                                        1
                                                        ? "เพดานต้องสูงกว่าวงเงินเกินสูงสุด ของทุกลำดับ"
                                                        : "วงเงินเกินสูงสุดต้องมากกว่าลำดับก่อนหน้า";

                                                    return Promise.reject(new Error(mapErrorText));
                                                  }
                                                  if (
                                                    value &&
                                                    limitCreditPercent &&
                                                    parseFloat(value) >
                                                      parseFloat(limitCreditPercent) &&
                                                    index ===
                                                      Number(
                                                        formSameCondition?.getFieldValue(
                                                          "editConditions",
                                                        )?.length,
                                                      ) -
                                                        1
                                                  ) {
                                                    return Promise.reject(
                                                      new Error(
                                                        `เพดานเกินค่าที่กำหนดในกฎ (${limitCreditPercent}%)`,
                                                      ),
                                                    );
                                                  }

                                                  return Promise.resolve();
                                                },
                                              },
                                            ]}
                                            required
                                          >
                                            <Input
                                              placeholder={
                                                index ===
                                                formSameCondition?.getFieldValue("editConditions")
                                                  ?.length -
                                                  1
                                                  ? "ระบุเพดาน"
                                                  : "ระบุวงเงินเกินสูงสุด"
                                              }
                                              autoComplete='off'
                                              suffix='%'
                                              style={{
                                                color: color.BK,
                                                borderColor: changedFields?.some(
                                                  (field) =>
                                                    field.groupNo - 1 === index &&
                                                    field.value !==
                                                      formSameCondition.getFieldValue([
                                                        "conditions",
                                                        index,
                                                        "max",
                                                      ]),
                                                )
                                                  ? color.warning
                                                  : undefined,
                                              }}
                                              onKeyDown={onInputNumberKeyPress}
                                              onChange={(e) => {
                                                const val = e.target.value;
                                                const editConditions =
                                                  formSameCondition.getFieldValue("editConditions");
                                                if (editConditions && editConditions[index + 1]) {
                                                  formSameCondition.setFieldValue(
                                                    ["editConditions", index + 1, "min"],
                                                    val,
                                                  );
                                                }
                                                formSameCondition.validateFields();
                                              }}
                                            />
                                          </Form.Item>
                                        </Col>
                                      </Row>
                                    </Card>
                                  ),
                                }))}
                            />
                          </Col>
                        </>
                      )}
                      <Col
                        span={18}
                        style={{
                          cursor:
                            changedFields &&
                            changedFields.some(
                              (field) => !field.text.includes("เปลี่ยนกฎการอนุมัติ"),
                            )
                              ? "pointer"
                              : "not-allowed",
                        }}
                        onClick={() => {
                          if (
                            changedFields &&
                            changedFields.some(
                              (field) => !field.text.includes("เปลี่ยนกฎการอนุมัติ"),
                            )
                          ) {
                            formSameCondition.setFieldsValue({
                              ...formSameCondition.getFieldsValue(true),
                              customConditions: formSameCondition.getFieldValue("conditions"),
                              editConditions: formSameCondition.getFieldValue("conditions"),
                            });
                            setChangedFields([]);
                          }
                        }}
                      >
                        <RedoOutlined
                          style={{
                            fontSize: "15px",
                            transform: "scaleY(-1)  rotate(80deg)",
                            color:
                              changedFields &&
                              changedFields.some(
                                (field) => !field.text.includes("เปลี่ยนกฎการอนุมัติ"),
                              )
                                ? color.primary
                                : color.Text3,
                          }}
                        />{" "}
                        <Text
                          color={
                            changedFields &&
                            changedFields.some(
                              (field) => !field.text.includes("เปลี่ยนกฎการอนุมัติ"),
                            )
                              ? "primary"
                              : "Text3"
                          }
                          level={6}
                        >
                          คืนค่าเริ่มต้นกฎการอนุมัติ
                        </Text>
                      </Col>
                    </>
                  ),
                },
              ]}
            />
          </Col>
        </Form>
      </div>
    );
  };

  const columnsStep3: any = [
    {
      title: "ชื่อร้านค้า",
      dataIndex: "customerName",
      key: "customerName",
      width: "38%",
      render: (value: any, record: any) => {
        return <>{value || "-"}</>;
      },
    },
    {
      title: "กลุ่มลูกค้า",
      dataIndex: "customerGroupName",
      key: "customerGroupName",
      width: "25%",
      render: (value: any, record: any) => {
        return <>{value || "-"}</>;
      },
    },
    {
      title: "เขต",
      dataIndex: "zone",
      key: "zone",
      width: "10%",
      render: (value: any, record: any) => {
        return <>{value || "-"}</>;
      },
    },
  ];

  const stepThree = () => {
    const dataForm = formSameCondition.getFieldsValue(true);
    return (
      <div key={2}>
        <div style={{ padding: "10px" }}>
          <Row style={{ paddingBottom: "10px" }} gutter={8}>
            <Text fontWeight={600}>สรุปเงื่อนไขเดียวกันให้</Text>&nbsp;&nbsp;
            <img src={icon.store} style={{ width: "20px", height: "20px" }} />
            &nbsp;&nbsp;
            <Text fontWeight={600}>
              {formSameCondition.getFieldValue("shopSelect")?.length || 0} ร้าน
            </Text>
          </Row>
        </div>
        <Card
          style={{ backgroundColor: "#FAFAFA" }}
          bodyStyle={{
            paddingTop: "6px",
            paddingBottom: "6px",
          }}
        >
          {openCategory.find((item) => item.key === "statusRule")?.status && (
            <Row justify={"start"} gutter={16} style={{ paddingBottom: "5px" }}>
              <Col span={5}>
                <Text color='Text3'>สั่งวงเงินเกิน</Text>
              </Col>
              <Col>
                <Tag
                  color={
                    formSameCondition.getFieldValue("statusRule") === "1" ? "#F0FDF4" : "#EFF2F9"
                  }
                >
                  <Text
                    level={6}
                    fontWeight={600}
                    color={
                      formSameCondition.getFieldValue("statusRule") === "1" ? "darkGreen" : "Grey"
                    }
                  >
                    {formSameCondition.getFieldValue("statusRule") === "1"
                      ? "เปิดใช้งาน"
                      : "ปิดใช้งาน"}
                  </Text>
                </Tag>
              </Col>
            </Row>
          )}
          {openCategory.find((item) => item.key === "statusLimitCredit")?.status && (
            <Row justify={"start"} gutter={16} style={{ paddingBottom: "5px" }}>
              <Col span={5}>
                <Text color='Text3'>เพดานวงเงินเกิน</Text>
              </Col>
              <Col>
                <Tag
                  color={
                    formSameCondition.getFieldValue("statusLimitCredit") === "1"
                      ? "#F0FDF4"
                      : "#EFF2F9"
                  }
                >
                  <Text
                    level={6}
                    fontWeight={600}
                    color={
                      formSameCondition.getFieldValue("statusLimitCredit") === "1"
                        ? "darkGreen"
                        : "Grey"
                    }
                  >
                    {formSameCondition.getFieldValue("statusLimitCredit") === "1"
                      ? "เปิดใช้งาน"
                      : "ปิดใช้งาน"}
                  </Text>
                </Tag>
              </Col>
            </Row>
          )}
          {openCategory.find((item) => item.key === "changeRule")?.status && (
            <>
              <Row justify={"start"} gutter={16}>
                <Col span={5}>
                  <Text color='Text3'>กฎการอนุมัติวงเงินเกิน</Text>
                </Col>
                <Col>
                  <Text>{formSameCondition.getFieldValue("ruleName")}</Text>{" "}
                  {changedFields?.some((field) => field.text.includes("%")) && (
                    <Tag style={{ borderRadius: "20px", borderColor: color.warning }}>
                      <Badge color={color.warning} />
                      &nbsp;
                      <Text
                        level={6}
                        fontWeight={600}
                        color='warning'
                        style={{ cursor: "pointer" }}
                      >
                        ปรับแต่ง
                      </Text>
                    </Tag>
                  )}
                </Col>
              </Row>
              <Row justify={"start"} gutter={16}>
                <Col span={5}>
                  <Text color='Text3'>% ผู้อนุมัติ</Text>
                </Col>
                {formSameCondition?.getFieldValue("editConditions")?.length > 0 && (
                  <>
                    {formSameCondition.getFieldValue("editConditions").map((item, index) => (
                      <React.Fragment key={index}>
                        <Col>
                          <Tag style={{ borderRadius: "20px", backgroundColor: "#1B4586" }}>
                            <Text level={6} fontWeight={600} color='white'>
                              {index + 1}
                            </Text>
                          </Tag>
                          <Text level={6}>
                            {item.roleName} :{" "}
                            {item.max ? ` ${item.min}%–${item.max}%` : `>${item.min}%`}{" "}
                          </Text>
                        </Col>
                      </React.Fragment>
                    ))}
                  </>
                )}
              </Row>
            </>
          )}
          {changedFields?.some((field) => field.text.includes("เพดาน")) && (
            <Row justify={"start"} gutter={16} style={{ paddingBottom: "5px" }}>
              <Col span={5}>
                <Text color='Text3'>% เพดานวงเงินเกิน</Text>
              </Col>
              <Col>
                <Text level={6}>
                  {Number(changedFields.find((field) => field.text.includes("เพดาน"))?.value) > 0
                    ? `${changedFields.find((field) => field.text.includes("เพดาน"))?.value || 0}%`
                    : `ไม่ระบุ % เพดาน`}
                </Text>
              </Col>
            </Row>
          )}
          {formSameCondition?.getFieldValue("shopError")?.length > 0 && (
            <Alert
              message={
                <>
                  <Text
                    level={6}
                  >{`มี ${formSameCondition?.getFieldValue("shopError")?.length || 0} ร้านค้าไม่สามารถปรับตามเงื่อนไขเดียวกันนี้ได้ เมื่อบันทึกร้านค้าเหล่านี้จะไม่ถูกใช้งานเงื่อนไขที่กำหนด `}</Text>
                  <Text
                    level={6}
                    color='primary'
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => setShopErrorModal(true)}
                  >
                    ดูร้านค้า
                  </Text>
                </>
              }
              type='warning'
              style={{ backgroundColor: "#FFF8F5", border: "none" }}
              showIcon
              icon={<WarningOutlined style={{ fontSize: "18px" }} />}
            />
          )}
        </Card>
        <br />
        <ConfigProvider
          theme={{
            components: {
              Table: {
                headerBg: "#F3F6F9",
                fontFamily: "IBM Plex Sans Thai",
                fontSize: 15,
                rowHoverBg: "none",
              },
            },
          }}
        >
          <Table
            columns={columnsStep3}
            dataSource={
              dataForm.shopError?.length > 0
                ? dataForm.shopSelect.filter(
                    (shop: any) =>
                      !dataForm.shopError?.some(
                        (error: any) => error.customerCompanyId === shop.customerCompanyId,
                      ),
                  )
                : dataForm.shopSelect || []
            }
            pagination={false}
            size='small'
          />
        </ConfigProvider>
      </div>
    );
  };

  const stepContent = [stepOne(), stepTwo(), stepThree()];

  const resetAllSearch = () => {
    setSearchText(undefined);
    setSearchCusGroup(undefined);
    setSearchZone(undefined);
    setSearchRuleIds(undefined);
  };

  const onNext = async () => {
    if (step === 0) {
      resetAllSearch();
      if (shopList.filter((shop: any) => shop.checked).length > 0) {
        setMessageErrorSteps([]);
        setStep(step + 1);
        formSameCondition.setFieldValue(
          "shopSelect",
          shopList.filter((shop: any) => shop.checked),
        );
      }
    } else if (step === 1) {
      setMessageErrorSteps([]);
      const dataForm = formSameCondition.getFieldsValue(true);
      formSameCondition.setFieldValue("shopError", []);
      if (
        (dataForm.statusRuleCategory || dataForm.statusLimitCreditCategory) &&
        dataForm.changeRule !== "1"
      ) {
        const checkShopWithoutRule = dataForm.shopSelect
          .filter((shop: any) => !shop.ruleId)
          .map((shop: any) => ({ ...shop, errorText: "ร้านค้าไม่มีกฎการอนุมัติ" }));

        const checkShopWithoutLimit = dataForm.shopSelect.filter(
          (shop: any) =>
            (shop.limitCreditPercent === null ||
              shop.limitCreditPercent === undefined ||
              shop.limitCreditPercent === 0) &&
            shop.ruleId !== null,
        );
        let mapErrorText = [];
        if (dataForm.statusLimitCredit === "1") {
          mapErrorText = checkShopWithoutLimit
            .map((shop) => {
              if (
                checkShopWithoutRule &&
                checkShopWithoutRule.find(
                  (shopWithoutRule) =>
                    `${shopWithoutRule.customerCompanyId}` === `${shop.customerCompanyId}`,
                )
              ) {
                return;
              }
              return { ...shop, errorText: "ร้านค้าไม่มี % เพดานวงเงินเกิน" };
            })
            .filter((shop) => shop !== undefined);
        }
        formSameCondition.setFieldValue("shopError", [...checkShopWithoutRule, ...mapErrorText]);
      }
      if (dataForm.ruleId) {
        formSameCondition.setFieldValue(
          "ruleName",
          ruleList.find((rule: any) => rule.ruleId === dataForm.ruleId)?.ruleName,
        );
      }

      try {
        await formSameCondition.validateFields();
        setStep(step + 1);
      } catch (error) {
        console.log("Validation failed:", error);
      }
    }
  };

  const onSubmit = async () => {
    setMessageErrorSteps([]);
    const findCustomLimit = changedFields?.some((field) => field.text.includes("เพดาน"));
    const dataForm = formSameCondition.getFieldsValue(true);
    const payload = {
      customerCompanyIds: dataForm.shopSelect
        .filter(
          (shop: any) =>
            !formSameCondition
              .getFieldValue("shopError")
              ?.some((error: any) => error.customerCompanyId === shop.customerCompanyId),
        )
        .map((shop: any) => shop.customerCompanyId),
      ruleId: dataForm.ruleId,
      statusRule: dataForm.statusRule === "1" ? true : dataForm.statusRule === "2" ? false : null,
      statusLimitCredit:
        dataForm.statusLimitCredit === "1"
          ? true
          : dataForm.statusLimitCredit === "2"
            ? false
            : null,
      customLimitCreditPercent: findCustomLimit
        ? (changedFields?.find((f) => f.text.includes("เพดาน"))?.value as number) || null
        : undefined,
      conditions: dataForm.editConditions,
      updateBy: profile?.firstname + " " + profile?.lastname,
    };

    await createShopSameCondition(payload).then((res) => {
      if (res.success) {
        setSameConditionModal(false);
        fetchList();
        setChangedFields([]);
        messageApi.success("บันทึกสำเร็จ");
      }
    });
  };

  return (
    <>
      <Modal
        open={sameCondition}
        centered
        onCancel={() => setSameConditionModal(false)}
        footer={null}
        keyboard={false}
        maskClosable={false}
        width={1000}
        title={
          <Text level={3} fontWeight={600}>
            เพิ่มเงื่อนไขเดียวกัน
          </Text>
        }
      >
        <Divider size='small' />
        <Steps
          className='advance-credit-steps'
          current={step}
          items={[
            {
              title: "เลือกร้านค้า",
            },
            {
              title: "กำหนดเงื่อนไข",
            },
            {
              title: "ยืนยัน",
            },
          ]}
        />
        <Divider size='small' />
        <div
          ref={scrollRef}
          style={{
            maxHeight: "480px",
            overflowY: "auto",
            overflowX: "hidden",
            position: "relative",
          }}
        >
          {stepContent[step]}
        </div>
        <br />
        <Row justify='space-between' gutter={12}>
          <Col span={10}>
            {step > 0 ? (
              <Button
                typeButton='primary-light'
                title='ย้อนกลับ'
                onClick={() => setStep(step - 1)}
                style={{ width: "18%" }}
              />
            ) : (
              <>
                {shopList.filter((shop: any) => shop.checked).length > 0 ? (
                  <Text>{`เลือก ${shopList.filter((shop: any) => shop.checked).length} ร้านค้า`}</Text>
                ) : (
                  <>
                    <Text>ยังไม่ได้เลือกร้านค้า</Text>
                  </>
                )}
              </>
            )}
          </Col>
          <Col span={11} style={{ paddingTop: "8px" }}>
            <Row justify={"end"}>
              <Text>
                {messageErrorSteps.find((item) => item.key === step)?.text && (
                  <Text color='error'>
                    {messageErrorSteps.find((item) => item.key === step)?.text}
                  </Text>
                )}
              </Text>
            </Row>
          </Col>
          <Col span={3}>
            <Button
              typeButton='primary'
              title={step === 2 ? "บันทึก" : "ถัดไป"}
              onClick={async () => {
                if (step === 0) {
                  shopList.filter((shop: any) => shop.checked).length > 0
                    ? onNext()
                    : setMessageErrorSteps([{ key: 0, text: "กรุณาเลือกร้านค้าอย่างน้อย 1 ร้าน" }]);
                } else if (step === 1) {
                  const dataForm = formSameCondition.getFieldsValue(true);
                  if (dataForm.changeRule === "1") {
                    try {
                      await formSameCondition.validateFields(["ruleId"]);
                      onNext();
                    } catch (error) {
                      console.log("Validation failed:", error);
                    }
                  } else {
                    openCategory.some((item) => item.status)
                      ? onNext()
                      : setMessageErrorSteps([
                          { key: 1, text: "กรุณาเลือกกำหนดเงื่อนไขอย่างน้อย 1 หัวข้อ" },
                        ]);
                  }
                } else if (step === 2) {
                  formSameCondition.getFieldValue("shopError")?.length ===
                  formSameCondition.getFieldValue("shopSelect")?.length
                    ? setMessageErrorSteps([
                        {
                          key: 2,
                          text: "ร้านค้าที่เลือกทั้งหมดไม่สามารถปรับตามเงื่อนไขเดียวกันนี้ได้ กรุณากลับไปแก้ไขร้านค้าหรือเงื่อนไข",
                        },
                      ])
                    : onSubmit();
                }
              }}
            />
          </Col>
        </Row>
      </Modal>
      {shopErrorModal && (
        <Modal
          maskClosable={false}
          open={shopErrorModal}
          centered
          onCancel={() => setShopErrorModal(false)}
          footer={null}
          width={850}
          title={
            <>
              <Text level={3} fontWeight={600}>
                ร้านค้าที่ไม่สามารถปรับตามเงื่อนไขได้
              </Text>
              <br />
              <Text>{formSameCondition?.getFieldValue("shopError")?.length || 0} ร้านค้า</Text>
            </>
          }
        >
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#F3F6F9",
                  fontFamily: "IBM Plex Sans Thai",
                  fontSize: 15,
                  rowHoverBg: "none",
                },
              },
            }}
          >
            <Table
              size='small'
              dataSource={formSameCondition.getFieldValue("shopError")}
              columns={[
                ...columnsStep3,
                { title: "หมายเหตุ", dataIndex: "errorText", key: "errorText" },
              ]}
              pagination={false}
              scroll={{ y: 300 }}
            />
          </ConfigProvider>
        </Modal>
      )}
    </>
  );
};

export const ExpandDetail = ({
  rowData,
  ruleList,
  fetchList,
}: {
  rowData: any;
  ruleList: any[];
  fetchList: () => void;
}) => {
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const { messageApi } = useMessageContext();
  const [modalEdit, setModalEdit] = useState<boolean>(false);
  const [detailApproveModal, setDetailApproveModal] = useState<{
    open: boolean;
    ruleConId?: string;
  }>({ open: false, ruleConId: "" });
  const [modalConfirm, setModalConfirm] = useState<boolean>(false);
  const [deleteRuleModal, setDeleteRuleModal] = useState<{
    open: boolean;
    ruleId: string;
    customerName?: string;
  }>({
    open: false,
    ruleId: "",
    customerName: "",
  });
  const [form] = Form.useForm();

  const [changedFields, setChangedFields] =
    useState<{ groupNo: number; text: string; value: any }[]>();

  const limitCreditPercent =
    rowData?.customLimitCreditPercent ||
    rowData?.customConditions[rowData?.customConditions.length - 1]?.max ||
    0;

  const loopSequence = (num: number) => {
    const sequence: any = [];
    const findData = rowData;
    for (let i = 1; i <= num; i++) {
      sequence.push(findData?.customConditions[i - 1]);
    }
    return sequence;
  };

  const mapValidateFields = () => {
    if (rowData?.statusCustom) {
      const mapChange = rowData?.editConditions
        ?.map((condition: any, index: number) => {
          if (index !== rowData?.editConditions?.length - 1) {
            if (condition?.statusCustomMax || condition?.statusCustomMin) {
              return {
                groupNo: condition?.groupNo,
                text: "",
                value: condition?.max,
              };
            }
          }
        })
        .filter((field: any) => field !== undefined);

      rowData?.statusCustomLimitCredit &&
        mapChange.push({
          groupNo: rowData?.editConditions?.length,
          text: "",
          value: rowData?.customLimitCreditPercent,
        });
      setChangedFields(mapChange);
    }
  };

  useEffect(() => {
    mapValidateFields();
    !rowData.statusCustom && setChangedFields([]);
  }, [rowData]);

  const mapMessageConfirm = (changedFields: any) => {
    const dataForm = form.getFieldsValue(true);
    const findRule = changedFields?.find((field) => field.text.includes("กฎการอนุมัติ"));
    const findMax = changedFields?.find((field) => field.text.includes("วงเงินเกินสูงสุด"));
    const findLimit = changedFields?.find((field) => field.text.includes("เพดาน"));
    let renderText = <></>;

    if (findRule) {
      const mapRule = ruleList.find((rule: any) => rule.ruleId === dataForm.ruleId);
      renderText = (
        <>
          {dataForm?.rule ? (
            <>
              <Text>● เปลี่ยนกฎการอนุมัติวงเงินเกิน</Text>
              <br />
              <div style={{ paddingLeft: "10%" }}>
                <Text>จากกฎเดิม</Text>{" "}
                <Text fontWeight={600}>{`"${dataForm?.rule?.ruleName}"`}</Text>
                <br />
                <Text>{`(การอนุมัติ ${dataForm?.conditions?.length} ลำดับ)`}</Text> <br />
                <Text>เป็นกฎใหม่</Text>{" "}
                <Text color='error' fontWeight={600}>{`"${mapRule.ruleName}"`}</Text>
                <br />
                <Text>{`(การอนุมัติ ${mapRule?.conditions?.length} ลำดับ)`}</Text> <br />
              </div>
            </>
          ) : (
            <>
              <Text>● ใช้กฎการอนุมัติวงเงินเกิน</Text>
              <br />
              <div style={{ paddingLeft: "10%" }}>
                <Text>เป็นกฎ</Text>{" "}
                <Text color='error' fontWeight={600}>
                  {`"${mapRule.ruleName}"`}
                </Text>
                <br />
                <Text>{`(การอนุมัติ ${mapRule?.conditions?.length} ลำดับ)`}</Text> <br />
              </div>
            </>
          )}
        </>
      );
    }
    if (findMax || findLimit) {
      renderText = (
        <>
          {renderText}
          <Text>● ปรับแต่ง</Text> {findMax && <Text color='warning'>% วงเงินเกินสูงสุด</Text>}{" "}
          {findMax && findLimit && <Text>และ</Text>}{" "}
          {findLimit && <Text color='warning'>% เพดานเกินวงเงิน</Text>}
        </>
      );
    }
    return renderText;
  };

  const onSubmit = async (changedFields: any) => {
    const findCustomLimit = changedFields?.some((field) => field.text.includes("เพดาน"));
    const payload = {
      ...form.getFieldsValue(true),
      conditions: form.getFieldValue("editConditions").map((condition: any) => ({
        ...condition,
        max: Number(condition.max) > 0 ? condition.max : null,
      })),
      customLimitCreditPercent: findCustomLimit
        ? (changedFields?.find((f) => f.text.includes("เพดาน"))?.value as number) || null
        : undefined,
      updateBy: profile?.firstname + " " + profile?.lastname,
    };
    if (payload.ruleCustomerCompanyId) {
      await updateRuleEachShop(payload).then((res) => {
        if (res.success) {
          setChangedFields([]);
          setModalConfirm(false);
          setModalEdit(false);
          messageApi.success("บันทึกสำเร็จ");
          fetchList();
        }
      });
    } else {
      payload.statusRule = false;
      await createRuleEachShop(payload).then((res) => {
        if (res.success) {
          setChangedFields([]);
          setModalConfirm(false);
          setModalEdit(false);
          messageApi.success("บันทึกสำเร็จ");
          fetchList();
        }
      });
    }
  };

  return (
    <>
      <Row justify={"end"}>
        <Col span={20}>
          <Col span={10}>
            <Text level={5}>{rowData?.rule?.ruleName}</Text>
            {rowData?.activeFromColumnKey === "statusLimitCredit" && (
              <>
                <br />
                <Text level={6} color='error'>
                  ไม่มี % เพดานวงเงินเกินในกฎ กรุณาระบุก่อนเปิดใช้งานเพดาน
                </Text>
              </>
            )}
          </Col>
          <br />
          {rowData?.customConditions?.length > 0 ? (
            <>
              <div style={{ maxHeight: "280px", overflowY: "auto", padding: "10px" }}>
                <TimeLineStyled
                  mode='left'
                  items={rowData?.customConditions.map((con, conIndex) => ({
                    dot: (
                      <Badge
                        key={conIndex + 1}
                        count={conIndex + 1}
                        color='#1B4586'
                        style={{
                          width: 20,
                          height: 20,
                          lineHeight: "20px",
                          borderRadius: "50%",
                          fontSize: 12,
                        }}
                      />
                    ),
                    color: conIndex === 0 ? "green" : "blue",
                    children: (
                      <SequnceDetail
                        detail={con}
                        sequence={loopSequence(con.groupNo)}
                        limitPercent={limitCreditPercent}
                        setDetailApproveModal={setDetailApproveModal}
                      />
                    ),
                  }))}
                />
              </div>
            </>
          ) : (
            <>
              <Text fontWeight={600}>ร้านไม่มีกฎการอนุมัติวงเงินเกิน</Text>
              <br />
              <Text>{`สามารถเพิ่มกฎให้กับร้านค้าที่ปุ่ม “แก้ไข”`}</Text>
            </>
          )}
          {!rowData?.statusLimitCredit &&
            rowData?.customConditions?.length > 0 &&
            rowData.statusRule && (
              <Row gutter={16}>
                <Col>
                  <img src={icon.icon_infinity} alt='infinity' style={{ height: "8px" }} />
                </Col>
                <Col>
                  <Text level={6}>สั่งซื้อวงเงินเกินได้ไม่จำกัด</Text>
                </Col>
              </Row>
            )}
          <Divider size='small' />
          <Row justify={"space-between"} gutter={8}>
            <Col style={{ paddingTop: "10px" }}>
              {rowData?.updateBy && (
                <Text level={6} color='Text3'>
                  {`อัปเดตล่าสุด ${dayjs(rowData?.updateDate).format("DD/MM/YYYY, HH:mm")} โดย ${rowData?.updateBy}`}
                </Text>
              )}
            </Col>
            <Col>
              <Row justify={"end"} gutter={8}>
                {rowData?.customConditions?.length > 0 && (
                  <Col>
                    <Permission permission={["advanceCreditLimitEachShop", "delete"]}>
                      <Button
                        typeButton='primary-light'
                        title='ลบกฎ'
                        onClick={() => {
                          setDeleteRuleModal({
                            open: true,
                            ruleId: rowData?.ruleCustomerCompanyId,
                            customerName: rowData?.customerName,
                          });
                        }}
                      />
                    </Permission>
                  </Col>
                )}
                <Col>
                  <Permission permission={["advanceCreditLimitEachShop", "edit"]}>
                    <Button
                      typeButton='primary'
                      title='แก้ไข'
                      onClick={() => {
                        mapValidateFields();
                        setModalEdit(true);
                        form.setFieldsValue(rowData);
                      }}
                    />
                  </Permission>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      {modalEdit && (
        <ModalConfirmChangeRule
          open={modalEdit}
          form={form}
          ruleList={ruleList}
          setModalEdit={setModalEdit}
          changedFields={changedFields}
          setChangedFields={setChangedFields}
          onSubmit={(changedFields) => {
            if (changedFields && changedFields.length > 0) {
              setModalEdit(false);
              setModalConfirm(true);
            } else {
              setModalEdit(false);
              onSubmit(changedFields);
            }
          }}
        />
      )}
      {modalConfirm && (
        <Modal
          open={modalConfirm}
          maskClosable={false}
          keyboard={false}
          closable={false}
          onCancel={() => setModalConfirm(false)}
          centered
          title={
            <Text level={3} fontWeight={600}>
              ยืนยันบันทึกแก้ไขรายละเอียดวงเงินเกิน
            </Text>
          }
          footer={null}
        >
          <Text level={3} fontWeight={600}>{`"${form.getFieldsValue(true).customerName}"`}</Text>
          <br />
          <Text>รายละเอียดการแก้ไข</Text>
          <br />
          <>{mapMessageConfirm(changedFields)}</>
          <br />
          <Text color='Text3' level={6}>
            โปรดตรวจสอบรายละเอียดอีกครั้งก่อนกดยืนยัน <br />
            เพราะมีผลต่อการสั่งซื้อของร้านค้า
          </Text>
          <Divider size='small' />
          <Row justify={"start"} gutter={8}>
            <Col span={4}>
              <Button
                typeButton='primary-light'
                title='ยกเลิก'
                onClick={() => {
                  setChangedFields([]);
                  setModalEdit(false);
                  setModalConfirm(false);
                }}
              />
            </Col>
            <Col span={12} />
            <Col span={4}>
              <Button
                typeButton='primary-light'
                title={changedFields && changedFields.length > 0 ? "ย้อนกลับ" : "ยืนยัน"}
                onClick={() => {
                  if (changedFields && changedFields.length > 0) {
                    setModalConfirm(false);
                    setModalEdit(true);
                  } else {
                    setModalConfirm(false);
                    setModalEdit(false);
                    onSubmit(changedFields);
                  }
                }}
              />
            </Col>
            <Col span={4}>
              <Button typeButton='primary' title='ยืนยัน' onClick={() => onSubmit(changedFields)} />
            </Col>
          </Row>
        </Modal>
      )}
      {detailApproveModal.open && (
        <ModalApproveDetail
          data={detailApproveModal}
          setDetailApproveModal={setDetailApproveModal}
        />
      )}
      {deleteRuleModal.open && (
        <Modal
          open={deleteRuleModal.open}
          centered
          closable={false}
          onCancel={() => setDeleteRuleModal({ open: false, ruleId: "", customerName: "" })}
          onOk={() => {
            deleteRuleEachShop({
              ruleCustomerCompanyId: deleteRuleModal.ruleId,
              updateBy: profile?.firstname + " " + profile?.lastname,
            }).then((res) => {
              if (res.success) {
                setDeleteRuleModal({ open: false, ruleId: "", customerName: "" });
                messageApi.open({
                  type: "error",
                  content: "ลบรายการแล้ว",
                  icon: <img src={icon.delete} style={{ width: 14, height: 16 }} />,
                });
                fetchList();
              }
            });
          }}
          okText='ลบกฎนี้'
          cancelText='ยกเลิก'
          okButtonProps={{ danger: true }}
          cancelButtonProps={{ style: { borderColor: color.error, color: color.error } }}
        >
          <Text level={2}>ยืนยันลบกฎการอนุมัติ</Text>
          <br />
          <Text level={2}>{`"${deleteRuleModal.customerName}"`}</Text>
          <br />
          <Text color='error' fontWeight={600}>
            ผลที่จะเกิดขึ้นทันที
          </Text>{" "}
          &nbsp;
          <Text color='error'>
            ร้านค้าที่ใช้กฎนี้จะไม่สามารถสั่งซื้อเกินวงเงินได้อีกต่อไป ระบบจะดำเนินการปิดอัตโนมัติ
          </Text>
          <div style={{ paddingTop: "8px" }}>
            <Alert
              message={
                <Text level={6}>
                  คำสั่งซื้อที่อยู่ระหว่างการพิจารณาวงเงินยังดำเนินต่อได้ตามปกติ
                  และจะใช้เงื่อนไขของกฎนี้จนกว่าการพิจารณาจะเสร็จสิ้น
                </Text>
              }
              style={{ backgroundColor: "#F3F6F9", borderColor: "#F3F6F9" }}
              showIcon
            />
          </div>
        </Modal>
      )}
    </>
  );
};

export const ModalConfirmChangeRule = ({
  open,
  form,
  ruleList,
  setModalEdit,
  onSubmit,
  changedFields,
  setChangedFields,
}: {
  open: boolean;
  form: any;
  ruleList: any;
  setModalEdit: any;
  onSubmit: (changedFields: any) => void;
  changedFields?: { groupNo: number; text: string; value: any }[];
  setChangedFields: any;
}) => {
  const dataForm = form.getFieldsValue(true);
  const watchCondition = Form.useWatch("editConditions", form);

  const onChangeRule = (value: any) => {
    const selectedRule = ruleList.find((rule: any) => rule.ruleId === value);
    form.setFieldsValue({
      ...form.getFieldsValue(true),
      ruleId: selectedRule?.ruleId,
      //conditions: selectedRule?.conditions,
      customConditions: selectedRule?.conditions ?? [],
      editConditions: selectedRule?.conditions ?? [],
    });
  };

  useEffect(() => {
    if (watchCondition?.length > 0) {
      const fields = watchCondition.map((_: any, i: number) => ["editConditions", i, "max"]);
      form.validateFields(fields).catch((e) => e);
    }
  }, [watchCondition, changedFields]);

  return (
    <>
      <Modal
        open={open}
        maskClosable={false}
        keyboard={false}
        closable={false}
        centered
        title={
          <Text level={4} fontWeight={600}>
            แก้ไขร้าน {dataForm?.customerName}
          </Text>
        }
        footer={null}
        width={800}
        onCancel={() => setModalEdit(false)}
      >
        <Form
          layout='vertical'
          form={form}
          onValuesChange={(changedValues) => {
            if (changedValues?.editConditions) {
              const indices: number[] = changedValues.editConditions
                .map((_: any, i: number) =>
                  changedValues.editConditions[i] !== undefined ? i : -1,
                )
                .filter((i: number) => i !== -1);
              if (indices.length > 0) {
                const editConditions = form.getFieldValue("editConditions") ?? [];
                const originalConditions = form.getFieldValue("conditions") ?? [];
                const conditionsLength = editConditions.length;
                setChangedFields((prev: any) => {
                  let next = [...(prev ?? [])];
                  indices.forEach((i: number) => {
                    const newMax = changedValues.editConditions[i]?.max;
                    const originalMax = originalConditions[i]?.max;
                    const isDifferent = String(newMax ?? "") !== String(originalMax ?? "");
                    const mapText =
                      i + 1 === conditionsLength ? "% เพดานวงเงินเกิน" : "% วงเงินเกินสูงสุด";
                    next = next.filter((field: any) => field.groupNo !== i + 1);
                    if (isDifferent) {
                      next.push({ groupNo: i + 1, text: mapText, value: newMax });
                    }
                  });
                  return next;
                });
              }
            } else {
              const checkRule = form?.getFieldsValue(true)?.rule?.ruleId === changedValues.ruleId;
              if (!checkRule) {
                setChangedFields((prev: any) => [
                  {
                    groupNo: changedValues["ruleId"],
                    text: "เปลี่ยนกฎการอนุมัติวงเงินเกิน",
                    value: "",
                  },
                ]);
              } else {
                setChangedFields(undefined);
              }
            }
          }}
        >
          <Col span={24} style={{ padding: "10px" }}>
            <Form.Item label='กฎการอนุมัติวงเงินเกิน' name='ruleId' required>
              <Select
                placeholder='เลือกกฎการอนุมัติ'
                options={ruleList?.map((rule: any) => ({
                  label: <Text>{rule?.ruleName}</Text>,
                  value: rule?.ruleId,
                  key: rule?.ruleName,
                }))}
                style={{ width: "100%", height: "40px" }}
                onChange={(value) => {
                  onChangeRule(value);
                }}
                optionRender={(option: any) => {
                  return (
                    <div
                      style={{
                        margin: 0,
                        lineHeight: "8px",
                        borderRadius: "4px",
                        backgroundColor:
                          option.value === form.getFieldValue("ruleId") ? "#EFF2F9" : "transparent",
                      }}
                    >
                      <Row justify={"space-between"} style={{ padding: "6px" }}>
                        <Col>
                          <Text>{option.label}</Text>
                        </Col>
                        {option.value === form.getFieldValue("ruleId") && (
                          <Col style={{ paddingTop: "6px" }}>
                            <CheckOutlined style={{ color: color.primary }} />
                          </Col>
                        )}
                      </Row>
                    </div>
                  );
                }}
              />
            </Form.Item>
          </Col>
          <Col span={24} style={{ padding: "10px" }}>
            {form?.getFieldValue("editConditions")?.length > 0 && (
              <TimeLineStyled
                mode='left'
                items={form?.getFieldValue("editConditions")?.map((item: any, index: number) => ({
                  dot: (
                    <Badge
                      key={item.groupNo}
                      count={index + 1}
                      color='#1B4586'
                      style={{
                        width: 20,
                        height: 20,
                        lineHeight: "20px",
                        borderRadius: "50%",
                        fontSize: 16,
                      }}
                    />
                  ),
                  color: index === 0 ? "green" : "blue",
                  children: (
                    <Card
                      bodyStyle={{
                        paddingTop: "6px",
                        paddingBottom: "6px",
                      }}
                    >
                      <Row justify={"space-between"} gutter={16}>
                        <Col span={12}>
                          <div style={{ paddingTop: "30px" }}>
                            <Text>{item.roleName}</Text>
                          </div>
                        </Col>
                        <Col span={6}>
                          <Form.Item
                            label='% วงเงินเกินต่ำสุด'
                            name={["editConditions", index, "min"]}
                          >
                            <Input
                              placeholder='ระบุ % วงเงินเกินต่ำสุด'
                              autoComplete='off'
                              suffix='%'
                              disabled
                              style={{ color: color.BK }}
                              onKeyDown={onInputNumberKeyPress}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item
                            label={
                              index === form?.getFieldValue("editConditions")?.length - 1
                                ? "% เพดานวงเงินเกิน"
                                : "% วงเงินเกินสูงสุด"
                            }
                            name={["editConditions", index, "max"]}
                            rules={[
                              {
                                required:
                                  index === form?.getFieldValue("editConditions")?.length - 1
                                    ? false
                                    : true,
                                message:
                                  index != form?.getFieldValue("editConditions")?.length - 1
                                    ? "โปรดระบุ % วงเงินเกินสูงสุด"
                                    : undefined,
                              },
                              {
                                validator: (_, value) => {
                                  const limitCreditPercent =
                                    (form.getFieldValue("conditions")?.length &&
                                      form.getFieldValue("conditions")[
                                        form.getFieldValue("conditions").length - 1
                                      ].max) ||
                                    0;
                                  if (parseFloat(value) === 0) {
                                    return Promise.reject(
                                      new Error("วงเงินเกินสูงสุดต้องการมากกว่า 0"),
                                    );
                                  }
                                  if (
                                    value &&
                                    form.getFieldValue(["editConditions", index + 1, "max"]) &&
                                    parseFloat(
                                      form.getFieldValue(["editConditions", index + 1, "max"]),
                                    ) <= parseFloat(value)
                                  ) {
                                    return Promise.reject(
                                      new Error("วงเงินเกินสูงสุดต้องน้อยกว่าลำดับถัดไป"),
                                    );
                                  }
                                  if (
                                    value &&
                                    form.getFieldValue(["editConditions", index - 1, "max"]) &&
                                    parseFloat(
                                      form.getFieldValue(["editConditions", index - 1, "max"]),
                                    ) >= parseFloat(value)
                                  ) {
                                    const mapErrorText =
                                      index === form?.getFieldValue("editConditions")?.length - 1
                                        ? "เพดานต้องสูงกว่าวงเงินเกินสูงสุด ของทุกลำดับ"
                                        : "วงเงินเกินสูงสุดต้องมากกว่าลำดับก่อนหน้า";
                                    return Promise.reject(new Error(mapErrorText));
                                  }

                                  if (
                                    value &&
                                    limitCreditPercent &&
                                    parseFloat(value) > parseFloat(limitCreditPercent) &&
                                    index ===
                                      Number(form?.getFieldValue("editConditions")?.length) - 1
                                  ) {
                                    return Promise.reject(
                                      new Error(
                                        `เพดานเกินค่าที่กำหนดในกฎ (${limitCreditPercent}%)`,
                                      ),
                                    );
                                  }
                                  return Promise.resolve();
                                },
                              },
                            ]}
                            required
                          >
                            <Input
                              placeholder={
                                index === form?.getFieldValue("editConditions")?.length - 1
                                  ? "ระบุเพดาน"
                                  : "ระบุวงเงินเกินสูงสุด"
                              }
                              autoComplete='off'
                              suffix='%'
                              style={{
                                color: color.BK,
                                borderColor: changedFields?.some(
                                  (field) =>
                                    field.groupNo - 1 === index &&
                                    field.value !==
                                      form.getFieldValue(["conditions", index, "max"]),
                                )
                                  ? color.warning
                                  : undefined,
                              }}
                              onKeyDown={onInputNumberKeyPress}
                              onChange={(e) => {
                                const val = e.target.value;
                                const editConditions = form.getFieldValue("editConditions");
                                if (editConditions && editConditions[index + 1]) {
                                  form.setFieldValue(["editConditions", index + 1, "min"], val);
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                  ),
                }))}
              />
            )}
          </Col>
        </Form>
        <Divider size='small' />
        <Row justify={"space-between"} gutter={8}>
          <Col
            span={18}
            style={{
              cursor:
                changedFields &&
                changedFields.some((field) => !field.text.includes("เปลี่ยนกฎการอนุมัติ"))
                  ? "pointer"
                  : "not-allowed",
            }}
            onClick={() => {
              if (
                changedFields &&
                changedFields.some((field) => !field.text.includes("เปลี่ยนกฎการอนุมัติ"))
              ) {
                form.setFieldsValue({
                  ...form.getFieldsValue(true),
                  customConditions: form.getFieldValue("conditions"),
                  editConditions: form.getFieldValue("conditions"),
                });
                setChangedFields([]);
              }
            }}
          >
            <RedoOutlined
              style={{
                fontSize: "15px",
                transform: "scaleY(-1)  rotate(80deg)",
                color:
                  changedFields &&
                  changedFields.some((field) => !field.text.includes("เปลี่ยนกฎการอนุมัติ"))
                    ? color.primary
                    : color.Text3,
              }}
            />{" "}
            <Text
              color={
                changedFields &&
                changedFields.some((field) => !field.text.includes("เปลี่ยนกฎการอนุมัติ"))
                  ? "primary"
                  : "Text3"
              }
              level={6}
            >
              คืนค่าเริ่มต้นกฎการอนุมัติ
            </Text>
          </Col>
          <Col>
            <Button
              typeButton='primary-light'
              title='ยกเลิก'
              onClick={() => {
                setModalEdit(false);
              }}
            />
          </Col>
          <Col>
            <Button
              typeButton='primary'
              title={
                changedFields &&
                changedFields.length > 0 &&
                changedFields.some((field) => field.text)
                  ? "ถัดไป"
                  : "ยืนยัน"
              }
              onClick={async () => {
                try {
                  await form.validateFields().then(() => {
                    onSubmit(changedFields);
                  });
                } catch (error) {
                  console.log("Validation failed:", error);
                }
              }}
            />
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export const FilterDrawer = ({
  filterDrawer,
  setFilterDrawer,
  setFilterList,
  filterList,
  limitCreditPercentMax,
  limitCreditPercentMin,
}: {
  filterDrawer: boolean;
  setFilterDrawer: (value: boolean) => void;
  setFilterList: (value: any) => void;
  filterList: any;
  limitCreditPercentMax: number;
  limitCreditPercentMin: number;
}) => {
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const [ruleList, setRuleList] = useState<any>([]);
  const [cusGroupList, setCusGroupList] = useState<any>([]);
  const [teamList, setTeamList] = useState<any>([]);
  const [zoneList, setZoneList] = useState<any>([]);
  const [searchList, setSearchList] = useState<any>({
    ...filterList,
    ruleIds: filterList?.noRule ? [...filterList.ruleIds, "none"] : filterList.ruleIds,
  });

  const fetchRule = async () => {
    await getAllRule(profile.company).then((res) => {
      setRuleList([{ ruleId: "none", ruleName: "ไม่มีกฎ" }].concat(res.data));
    });
  };
  const fetchCustomerGroup = async () => {
    await getShopGroup({ page: 1, take: 999, company: profile.company, isActive: true }).then(
      (res) => {
        setCusGroupList(res.responseData.data);
      },
    );
  };
  const fetchZone = async () => {
    await zoneDatasource.getAllZoneByCompany(profile.company).then((res) => {
      const mapGroupChecked = Object.values(
        res.reduce((acc: any, item: any) => {
          const teamId = item.team.teamId;
          if (!acc[teamId]) {
            acc[teamId] = {
              teamId,
              teamName: item.team.teamName,
              zones: [],
              checked: filterList.team?.includes(teamId) || false,
            };
          }
          acc[teamId].zones.push(item);
          return acc;
        }, {}),
      );
      setTeamList(mapGroupChecked);
      setZoneList(
        res.map((zone: any) => ({
          ...zone,
          checked: filterList.zone?.includes(zone.zoneName) || false,
        })),
      );
    });
  };

  useEffectOnce(() => {
    fetchRule();
    fetchCustomerGroup();
    fetchZone();
  });

  const checkedItems = [
    { label: "เปิดใช้งาน", value: "true" },
    { label: "ปิดใช้งาน", value: "false" },
  ];

  const onCheckBoxHandleTeam = (e: any) => {
    const mapChecked = zoneList.map((z: any) =>
      z.zoneName === e.target.value ? { ...z, checked: e.target.checked } : z,
    );
    const findTeamInZone = mapChecked.find((zone: any) => zone.zoneName === e.target.value);
    const filterTeam = teamList?.find((team: any) => team.teamId === findTeamInZone?.team?.teamId);
    const compareTeam =
      mapChecked?.filter(
        (zone: any) =>
          zone.team.teamId === findTeamInZone?.team?.teamId && zone.checked === e.target.checked,
      ).length === filterTeam?.zones?.length;

    setTeamList((prev: any) =>
      prev.map((team: any) =>
        team.teamId === findTeamInZone?.team?.teamId
          ? {
              ...team,
              checked: compareTeam ? e.target.checked : true,
            }
          : team,
      ),
    );
    setZoneList(mapChecked);
    setSearchList({
      ...searchList,
      team: [...(searchList?.team ?? []), findTeamInZone.team?.teamId],
      zone: mapChecked,
    });
  };

  const items: any = [
    {
      key: "1",
      label: (
        <Text fontWeight={600} level={6}>
          สั่งวงเงินเกิน {searchList?.statusRule && `(${searchList?.statusRule?.length})`}
        </Text>
      ),
      children: (
        <>
          <Checkbox.Group
            value={searchList.statusRule}
            options={checkedItems}
            style={{ display: "flex", flexDirection: "column" }}
            onChange={(e) => {
              if (e.length === 0) {
                setSearchList({ ...searchList, statusRule: undefined });
                return;
              }
              setSearchList({ ...searchList, statusRule: e });
            }}
          />
        </>
      ),
    },
    {
      key: "2",
      label: (
        <Text fontWeight={600} level={6}>
          เพดานวงเงินเกิน{" "}
          {searchList?.statusLimitCredit && `(${searchList?.statusLimitCredit?.length})`}
        </Text>
      ),
      children: (
        <>
          <Checkbox.Group
            value={searchList.statusLimitCredit}
            options={checkedItems}
            style={{ display: "flex", flexDirection: "column" }}
            onChange={(e) => {
              if (e.length === 0) {
                setSearchList({ ...searchList, statusLimitCredit: undefined });
                return;
              }
              setSearchList({ ...searchList, statusLimitCredit: e });
            }}
          />
        </>
      ),
    },
    {
      key: "3",
      label: (
        <Text fontWeight={600} level={6}>
          ช่วง % เพดานวงเงินเกิน
        </Text>
      ),
      children: (
        <>
          <Row justify={"space-between"} gutter={8}>
            <Col span={12}>
              <Input
                placeholder={`${limitCreditPercentMin}`}
                suffix='%'
                inputMode='numeric'
                value={searchList.limitCreditPercentMin}
                onChange={(e) => {
                  const rawValue = e.target.value.replace(/[^0-9]/g, "");
                  const value = Number(rawValue);
                  if (value > 0) {
                    setSearchList({
                      ...searchList,
                      limitCreditPercentMin: Math.min(
                        value,
                        searchList.limitCreditPercentMax ?? limitCreditPercentMax,
                      ),
                    });
                  } else {
                    setSearchList({
                      ...searchList,
                      limitCreditPercentMin: e.target.value ? e.target.value.toString() : undefined,
                    });
                  }
                }}
                onBlur={(e: any) => {
                  if (e.target.value && Number(e.target.value) < limitCreditPercentMin) {
                    setSearchList((prev) => ({
                      ...prev,
                      limitCreditPercentMin: limitCreditPercentMin,
                    }));
                  }
                }}
                onKeyDown={(e: any) => {
                  onInputNumberKeyPress(e);
                  const rawValue = e.target.value.replace(/[^0-9]/g, "");
                  const value = rawValue ? Number(rawValue) : 0;
                  if (e.key === "Tab") {
                    if (value < limitCreditPercentMin) {
                      setSearchList((prev) => ({
                        ...prev,
                        limitCreditPercentMin: limitCreditPercentMin,
                      }));
                    }
                  }
                }}
              />
            </Col>
            <Col span={12}>
              <Input
                placeholder={`${limitCreditPercentMax}`}
                suffix='%'
                inputMode='numeric'
                value={searchList.limitCreditPercentMax}
                onChange={(e) => {
                  const rawValue = e.target.value.replace(/[^0-9]/g, "");
                  const value = Number(rawValue);
                  if (value > 0) {
                    setSearchList({
                      ...searchList,
                      limitCreditPercentMax: Math.min(value, limitCreditPercentMax),
                    });
                  } else {
                    setSearchList({
                      ...searchList,
                      limitCreditPercentMax: e.target.value ? e.target.value.toString() : undefined,
                    });
                  }
                }}
                onBlur={(e: any) => {
                  if (
                    searchList.limitCreditPercentMin &&
                    e.target.value < searchList.limitCreditPercentMin
                  ) {
                    setSearchList((prev) => ({
                      ...prev,
                      limitCreditPercentMax: prev.limitCreditPercentMax,
                    }));
                  }
                  setSearchList((prev) => ({
                    ...prev,
                    limitCreditPercentMax: e.target.value ? e.target.value.toString() : undefined,
                  }));
                }}
                onKeyDown={(e: any) => {
                  onInputNumberKeyPress(e);
                  setSearchList((prev) => ({
                    ...prev,
                    limitCreditPercentMax: e.target.value ? e.target.value.toString() : undefined,
                  }));
                }}
              />
            </Col>
          </Row>
          <ConfigProvider
            theme={{
              components: {
                Slider: {
                  dotSize: 10,
                  trackBg: "#0068F4",
                  trackHoverBg: "#0068F4",
                  dotActiveBorderColor: "#0068F4",
                },
              },
            }}
          >
            <Slider
              marks={
                limitCreditPercentMax < 100
                  ? {
                      [limitCreditPercentMin]: limitCreditPercentMin + "%",
                      [limitCreditPercentMax]: limitCreditPercentMax + "%",
                      [limitCreditPercentMax < 100 ? 100 : limitCreditPercentMax]:
                        limitCreditPercentMax < 100 ? "100%" : limitCreditPercentMax + "%",
                    }
                  : {
                      [limitCreditPercentMin]: limitCreditPercentMin + "%",
                      [limitCreditPercentMax < 100 ? 100 : limitCreditPercentMax]:
                        limitCreditPercentMax < 100 ? "100%" : limitCreditPercentMax + "%",
                    }
              }
              range={{ draggableTrack: true }}
              min={limitCreditPercentMin ?? 0}
              max={limitCreditPercentMax < 100 ? 100 : limitCreditPercentMax}
              value={[searchList.limitCreditPercentMin ?? 0, searchList.limitCreditPercentMax]}
              onChange={(newValue) => {
                const [min, max] = newValue as number[];
                if (max > limitCreditPercentMax) {
                  return;
                }
                setSearchList({
                  ...searchList,
                  limitCreditPercentMin: min,
                  limitCreditPercentMax: Math.min(max, limitCreditPercentMax),
                });
              }}
            />
          </ConfigProvider>
        </>
      ),
    },
    {
      key: "4",
      label: (
        <Text fontWeight={600} level={6}>
          กฎการอนุมัติวงเงินเกิน {searchList?.ruleIds && `(${searchList?.ruleIds?.length})`}
        </Text>
      ),
      children: (
        <>
          <Checkbox.Group
            value={searchList.ruleIds}
            options={ruleList?.map((rule: any) => ({
              label: rule.ruleName,
              value: rule.ruleId,
            }))}
            style={{ display: "flex", flexDirection: "column" }}
            onChange={(e) => {
              if (e.length === 0) {
                setSearchList({ ...searchList, ruleIds: undefined });
                return;
              }
              setSearchList({ ...searchList, ruleIds: e });
            }}
          />
        </>
      ),
    },
    {
      key: "5",
      label: (
        <Text fontWeight={600} level={6}>
          สถานะปรับแต่ง {searchList?.statusCustom && `(${searchList?.statusCustom?.length})`}
        </Text>
      ),
      children: (
        <>
          <Checkbox.Group
            options={[
              { label: "ค่าเริ่มต้น", value: "false" },
              { label: "ปรับแต่ง", value: "true" },
            ]}
            style={{ display: "flex", flexDirection: "column" }}
            value={searchList.statusCustom}
            onChange={(e) => {
              if (e.length === 0) {
                setSearchList({ ...searchList, statusCustom: undefined });
                return;
              }
              setSearchList({ ...searchList, statusCustom: e });
            }}
          />
        </>
      ),
    },
    {
      key: "6",
      label: (
        <Text fontWeight={600} level={6}>
          กลุ่มลูกค้า{" "}
          {searchList?.customerGroupName && `(${searchList?.customerGroupName?.length})`}
        </Text>
      ),
      children: (
        <>
          <Checkbox.Group
            value={searchList.customerGroupName}
            options={cusGroupList?.map((group: any) => ({
              label: group.customerGroupName,
              value: group.customerGroupName,
            }))}
            style={{ display: "flex", flexDirection: "column" }}
            onChange={(e) => {
              if (e.length === 0) {
                setSearchList({ ...searchList, customerGroupName: undefined });
                return;
              }
              setSearchList({ ...searchList, customerGroupName: e });
            }}
          />
        </>
      ),
    },
    {
      key: "7",
      label: (
        <Text fontWeight={600} level={6}>
          ทีม{" "}
          {teamList.filter((team: any) => team.checked).length > 0 &&
            `(${teamList.filter((team: any) => team.checked).length})`}
        </Text>
      ),
      children: (
        <>
          <Col span={12}>
            {teamList.map((team: any) => (
              <div key={team.teamId}>
                <Checkbox
                  checked={team.checked}
                  value={team.teamId}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    const teamId = e.target.value;
                    const mapTeam = teamList.map((t: any) =>
                      t.teamId === teamId ? { ...t, checked } : t,
                    );
                    setTeamList(mapTeam);
                    const findZone = mapTeam.find((team: any) => team?.teamId === teamId).zones;
                    const mapZoneChecked = zoneList?.map((zone: any) => ({
                      ...zone,
                      checked: findZone?.find((z: any) => z.zoneName === zone.zoneName)
                        ? checked
                        : zone.checked,
                    }));
                    setZoneList(mapZoneChecked);
                    setSearchList({
                      ...searchList,
                      team: searchList?.team
                        ? [...searchList.team, e.target.value]
                        : [e.target.value],
                      zone: zoneList?.map((zone: any) => ({
                        ...zone,
                        checked: mapZoneChecked?.find((z: any) => z.zoneName === zone.zoneName)
                          ?.checked,
                      })),
                    });
                  }}
                >
                  {team.teamName}
                </Checkbox>
              </div>
            ))}
          </Col>
        </>
      ),
    },
    {
      key: "8",
      label: (
        <Text fontWeight={600} level={6}>
          เขตการขาย{" "}
          {zoneList?.filter((z) => z.checked).length > 0 &&
            `(${zoneList?.filter((z) => z.checked).length})`}
        </Text>
      ),
      children: (
        <>
          <Row gutter={24}>
            <Col span={12}>
              {zoneList?.slice(0, Math.ceil(zoneList?.length / 2)).map((zone: any) => (
                <div key={zone.zoneName}>
                  <Checkbox
                    checked={zone.checked}
                    value={zone.zoneName}
                    onChange={(e) => {
                      onCheckBoxHandleTeam(e);
                    }}
                  >
                    {zone.zoneName}
                  </Checkbox>
                </div>
              ))}
            </Col>
            <Col span={12}>
              {zoneList?.slice(Math.ceil(zoneList?.length / 2)).map((zone: any) => (
                <div key={zone.zoneName}>
                  <Checkbox
                    checked={zone.checked}
                    value={zone.zoneName}
                    onChange={(e) => {
                      onCheckBoxHandleTeam(e);
                    }}
                  >
                    {zone.zoneName}
                  </Checkbox>
                </div>
              ))}
            </Col>
          </Row>
        </>
      ),
    },
  ];

  return (
    <Drawer
      title={
        <Row justify={"space-between"} gutter={8}>
          <Col style={{ paddingTop: "8px" }}>
            <Text level={4} fontWeight={600}>
              ตัวกรอง
            </Text>
          </Col>
          <Row justify={"end"} gutter={8}>
            <Col>
              <Button
                typeButton='primary-light'
                title='ล้าง'
                onClick={() => {
                  setSearchList({
                    statusRule: undefined,
                    statusLimitCredit: undefined,
                    limitCreditPercentMin: undefined,
                    limitCreditPercentMax: undefined,
                    ruleIds: undefined,
                    noRule: false,
                    customerGroupName: undefined,
                    zone: undefined,
                    team: undefined,
                  });
                  setZoneList(zoneList.map((zone: any) => ({ ...zone, checked: false })));
                  setTeamList(teamList.map((team: any) => ({ ...team, checked: false })));
                }}
              />
            </Col>
            <Col>
              <Button
                typeButton='primary'
                title='ตกลง'
                onClick={() => {
                  const zoneChecked = zoneList.filter((zone: any) => zone.checked);
                  const teamChecked = teamList.filter((team: any) => team.checked);
                  const mapSearch = {
                    ...searchList,
                    noRule: searchList.ruleIds?.includes("none") ? true : false,
                    ruleIds: searchList.ruleIds?.filter((ruleId: any) => ruleId !== "none"),
                    zone:
                      zoneChecked.length > 0
                        ? zoneChecked.map((zone: any) => zone.zoneName)
                        : undefined,
                    team:
                      teamChecked.length > 0
                        ? teamChecked.map((team: any) => team.teamId)
                        : undefined,
                  };
                  setFilterList(mapSearch);
                  setFilterDrawer(false);
                }}
              />
            </Col>
          </Row>
        </Row>
      }
      placement='right'
      closable={{ "aria-label": "Close Button" }}
      onClose={() => setFilterDrawer(false)}
      open={filterDrawer}
      keyboard={false}
      maskClosable={false}
    >
      <Alert
        message={<Text level={6}>ไม่เลือกทุกตัวเลือกในหัวข้อ = แสดงทั้งหมด</Text>}
        type='info'
        showIcon
      />
      <br />
      <Collapse
        ghost
        style={{ backgroundColor: "white" }}
        items={items}
        bordered={false}
        defaultActiveKey={["1", "2", "3", "4", "5", "6", "7", "8"]}
        expandIconPosition='end'
      />
    </Drawer>
  );
};
